const _A = "Accuracy";
const _AA = "AverageAccuracy";
const _ADSU = "AnnotationDataS3Uri";
const _AFS = "AverageF1Score";
const _AM = "AugmentedManifests";
const _AMA = "ActiveModelArn";
const _AMLI = "AugmentedManifestsListItem";
const _AN = "AttributeNames";
const _AP = "AveragePrecision";
const _AR = "AverageRecall";
const _An = "Annotations";
const _B = "Block";
const _BB = "BoundingBox";
const _BDDL = "BatchDetectDominantLanguage";
const _BDDLIR = "BatchDetectDominantLanguageItemResult";
const _BDDLR = "BatchDetectDominantLanguageRequest";
const _BDDLRa = "BatchDetectDominantLanguageResponse";
const _BDE = "BatchDetectEntities";
const _BDEIR = "BatchDetectEntitiesItemResult";
const _BDER = "BatchDetectEntitiesRequest";
const _BDERa = "BatchDetectEntitiesResponse";
const _BDKP = "BatchDetectKeyPhrases";
const _BDKPIR = "BatchDetectKeyPhrasesItemResult";
const _BDKPR = "BatchDetectKeyPhrasesRequest";
const _BDKPRa = "BatchDetectKeyPhrasesResponse";
const _BDS = "BatchDetectSentiment";
const _BDSIR = "BatchDetectSentimentItemResult";
const _BDSIRa = "BatchDetectSyntaxItemResult";
const _BDSR = "BatchDetectSentimentRequest";
const _BDSRa = "BatchDetectSentimentResponse";
const _BDSRat = "BatchDetectSyntaxRequest";
const _BDSRatc = "BatchDetectSyntaxResponse";
const _BDSa = "BatchDetectSyntax";
const _BDTS = "BatchDetectTargetedSentiment";
const _BDTSIR = "BatchDetectTargetedSentimentItemResult";
const _BDTSR = "BatchDetectTargetedSentimentRequest";
const _BDTSRa = "BatchDetectTargetedSentimentResponse";
const _BI = "BlockId";
const _BIE = "BatchItemError";
const _BIEL = "BatchItemErrorList";
const _BO = "BeginOffset";
const _BR = "BlockReference";
const _BRl = "BlockReferences";
const _BSLEE = "BatchSizeLimitExceededException";
const _BT = "BlockType";
const _Bl = "Blocks";
const _By = "Bytes";
const _C = "Classes";
const _CB = "ChildBlocks";
const _CBI = "ChildBlockId";
const _CBh = "ChildBlock";
const _CD = "ClassifyDocument";
const _CDC = "CreateDocumentClassifier";
const _CDCR = "CreateDocumentClassifierRequest";
const _CDCRr = "CreateDocumentClassifierResponse";
const _CDR = "ClassifyDocumentRequest";
const _CDRl = "ClassifyDocumentResponse";
const _CDRr = "CreateDatasetRequest";
const _CDRre = "CreateDatasetResponse";
const _CDr = "CreateDataset";
const _CE = "CreateEndpoint";
const _CEM = "ClassifierEvaluationMetrics";
const _CER = "CreateEndpointRequest";
const _CERR = "CreateEntityRecognizerRequest";
const _CERRr = "CreateEntityRecognizerResponse";
const _CERr = "CreateEndpointResponse";
const _CERre = "CreateEntityRecognizer";
const _CF = "CreateFlywheel";
const _CFR = "CreateFlywheelRequest";
const _CFRr = "CreateFlywheelResponse";
const _CIS = "CustomerInputString";
const _CISL = "CustomerInputStringList";
const _CIU = "CurrentInferenceUnits";
const _CM = "ClassifierMetadata";
const _CME = "ConcurrentModificationException";
const _CPE = "ContainsPiiEntities";
const _CPER = "ContainsPiiEntitiesRequest";
const _CPERo = "ContainsPiiEntitiesResponse";
const _CRT = "ClientRequestToken";
const _CT = "CreationTime";
const _CTA = "CreationTimeAfter";
const _CTB = "CreationTimeBefore";
const _Co = "Count";
const _D = "Description";
const _DA = "DatasetArn";
const _DAML = "DatasetAugmentedManifestsList";
const _DAMLI = "DatasetAugmentedManifestsListItem";
const _DARA = "DataAccessRoleArn";
const _DC = "DocumentClass";
const _DCA = "DocumentClassifierArn";
const _DCAML = "DocumentClassifierAugmentedManifestsList";
const _DCC = "DocumentClassificationConfig";
const _DCD = "DocumentClassifierDocuments";
const _DCF = "DocumentClassifierFilter";
const _DCIDC = "DocumentClassifierInputDataConfig";
const _DCJF = "DocumentClassificationJobFilter";
const _DCJP = "DocumentClassificationJobProperties";
const _DCJPL = "DocumentClassificationJobPropertiesList";
const _DCN = "DocumentClassifierName";
const _DCODC = "DocumentClassifierOutputDataConfig";
const _DCP = "DocumentClassifierProperties";
const _DCPL = "DocumentClassifierPropertiesList";
const _DCS = "DocumentClassifierSummary";
const _DCSL = "DocumentClassifierSummariesList";
const _DD = "DescribeDataset";
const _DDARA = "DesiredDataAccessRoleArn";
const _DDC = "DeleteDocumentClassifier";
const _DDCIDC = "DatasetDocumentClassifierInputDataConfig";
const _DDCJ = "DescribeDocumentClassificationJob";
const _DDCJR = "DescribeDocumentClassificationJobRequest";
const _DDCJRe = "DescribeDocumentClassificationJobResponse";
const _DDCR = "DeleteDocumentClassifierRequest";
const _DDCRe = "DeleteDocumentClassifierResponse";
const _DDCRes = "DescribeDocumentClassifierRequest";
const _DDCResc = "DescribeDocumentClassifierResponse";
const _DDCe = "DescribeDocumentClassifier";
const _DDL = "DetectDominantLanguage";
const _DDLDJ = "DescribeDominantLanguageDetectionJob";
const _DDLDJR = "DescribeDominantLanguageDetectionJobRequest";
const _DDLDJRe = "DescribeDominantLanguageDetectionJobResponse";
const _DDLR = "DetectDominantLanguageRequest";
const _DDLRe = "DetectDominantLanguageResponse";
const _DDR = "DescribeDatasetRequest";
const _DDRe = "DescribeDatasetResponse";
const _DE = "DeleteEndpoint";
const _DEDJ = "DescribeEntitiesDetectionJob";
const _DEDJR = "DescribeEntitiesDetectionJobRequest";
const _DEDJRe = "DescribeEntitiesDetectionJobResponse";
const _DEDJRes = "DescribeEventsDetectionJobRequest";
const _DEDJResc = "DescribeEventsDetectionJobResponse";
const _DEDJe = "DescribeEventsDetectionJob";
const _DER = "DeleteEndpointRequest";
const _DERA = "DatasetEntityRecognizerAnnotations";
const _DERD = "DatasetEntityRecognizerDocuments";
const _DEREL = "DatasetEntityRecognizerEntityList";
const _DERIDC = "DatasetEntityRecognizerInputDataConfig";
const _DERR = "DeleteEntityRecognizerRequest";
const _DERRe = "DeleteEntityRecognizerResponse";
const _DERRes = "DescribeEntityRecognizerRequest";
const _DERResc = "DescribeEntityRecognizerResponse";
const _DERe = "DeleteEndpointResponse";
const _DERel = "DeleteEntityRecognizer";
const _DERes = "DescribeEndpointRequest";
const _DEResc = "DescribeEndpointResponse";
const _DERescr = "DescribeEntityRecognizer";
const _DERet = "DetectEntitiesRequest";
const _DERete = "DetectEntitiesResponse";
const _DEe = "DescribeEndpoint";
const _DEet = "DetectEntities";
const _DF = "DatasetFilter";
const _DFI = "DescribeFlywheelIteration";
const _DFIR = "DescribeFlywheelIterationRequest";
const _DFIRe = "DescribeFlywheelIterationResponse";
const _DFR = "DeleteFlywheelRequest";
const _DFRe = "DeleteFlywheelResponse";
const _DFRes = "DescribeFlywheelRequest";
const _DFResc = "DescribeFlywheelResponse";
const _DFa = "DataFormat";
const _DFe = "DeleteFlywheel";
const _DFes = "DescribeFlywheel";
const _DIDC = "DatasetInputDataConfig";
const _DIU = "DesiredInferenceUnits";
const _DKP = "DetectKeyPhrases";
const _DKPDJ = "DescribeKeyPhrasesDetectionJob";
const _DKPDJR = "DescribeKeyPhrasesDetectionJobRequest";
const _DKPDJRe = "DescribeKeyPhrasesDetectionJobResponse";
const _DKPR = "DetectKeyPhrasesRequest";
const _DKPRe = "DetectKeyPhrasesResponse";
const _DL = "DocumentLabel";
const _DLDJF = "DominantLanguageDetectionJobFilter";
const _DLDJP = "DominantLanguageDetectionJobProperties";
const _DLDJPL = "DominantLanguageDetectionJobPropertiesList";
const _DLKKI = "DataLakeKmsKeyId";
const _DLSU = "DataLakeS3Uri";
const _DLo = "DominantLanguage";
const _DM = "DocumentMetadata";
const _DMA = "DesiredModelArn";
const _DMI = "DescriptiveMentionIndex";
const _DN = "DatasetName";
const _DP = "DatasetProperties";
const _DPE = "DetectPiiEntities";
const _DPEDJ = "DescribePiiEntitiesDetectionJob";
const _DPEDJR = "DescribePiiEntitiesDetectionJobRequest";
const _DPEDJRe = "DescribePiiEntitiesDetectionJobResponse";
const _DPER = "DetectPiiEntitiesRequest";
const _DPERe = "DetectPiiEntitiesResponse";
const _DPL = "DatasetPropertiesList";
const _DRA = "DocumentReadAction";
const _DRC = "DocumentReaderConfig";
const _DRM = "DocumentReadMode";
const _DRP = "DeleteResourcePolicy";
const _DRPR = "DeleteResourcePolicyRequest";
const _DRPRe = "DeleteResourcePolicyResponse";
const _DRPRes = "DescribeResourcePolicyRequest";
const _DRPResc = "DescribeResourcePolicyResponse";
const _DRPe = "DescribeResourcePolicy";
const _DS = "DetectSentiment";
const _DSC = "DataSecurityConfig";
const _DSDJ = "DescribeSentimentDetectionJob";
const _DSDJR = "DescribeSentimentDetectionJobRequest";
const _DSDJRe = "DescribeSentimentDetectionJobResponse";
const _DSR = "DetectSentimentRequest";
const _DSRe = "DetectSentimentResponse";
const _DSRet = "DetectSyntaxRequest";
const _DSRete = "DetectSyntaxResponse";
const _DSU = "DatasetS3Uri";
const _DSe = "DetectSyntax";
const _DT = "DocumentType";
const _DTC = "DetectToxicContent";
const _DTCR = "DetectToxicContentRequest";
const _DTCRe = "DetectToxicContentResponse";
const _DTDJ = "DescribeTopicsDetectionJob";
const _DTDJR = "DescribeTopicsDetectionJobRequest";
const _DTDJRe = "DescribeTopicsDetectionJobResponse";
const _DTLI = "DocumentTypeListItem";
const _DTS = "DetectTargetedSentiment";
const _DTSDJ = "DescribeTargetedSentimentDetectionJob";
const _DTSDJR = "DescribeTargetedSentimentDetectionJobRequest";
const _DTSDJRe = "DescribeTargetedSentimentDetectionJobResponse";
const _DTSR = "DetectTargetedSentimentRequest";
const _DTSRe = "DetectTargetedSentimentResponse";
const _DTa = "DatasetType";
const _De = "Detail";
const _Do = "Documents";
const _E = "Entities";
const _EA = "EndpointArn";
const _EC = "ErrorCode";
const _ECLI = "ExtractedCharactersListItem";
const _ECx = "ExtractedCharacters";
const _EDJF = "EntitiesDetectionJobFilter";
const _EDJFv = "EventsDetectionJobFilter";
const _EDJP = "EntitiesDetectionJobProperties";
const _EDJPL = "EntitiesDetectionJobPropertiesList";
const _EDJPLv = "EventsDetectionJobPropertiesList";
const _EDJPv = "EventsDetectionJobProperties";
const _EF = "EndpointFilter";
const _EL = "ErrorList";
const _ELI = "ErrorsListItem";
const _ELn = "EntityList";
const _ELnt = "EntityLabel";
const _EM = "ErrorMessage";
const _EMA = "EvaluatedModelArn";
const _EMM = "EvaluatedModelMetrics";
const _EMSP = "EvaluationManifestS3Prefix";
const _EMv = "EvaluationMetrics";
const _EN = "EndpointName";
const _EO = "EndOffset";
const _EP = "EndpointProperties";
const _EPL = "EndpointPropertiesList";
const _ERA = "EntityRecognizerArn";
const _ERAML = "EntityRecognizerAugmentedManifestsList";
const _ERAn = "EntityRecognizerAnnotations";
const _ERC = "EntityRecognitionConfig";
const _ERD = "EntityRecognizerDocuments";
const _EREL = "EntityRecognizerEntityList";
const _EREM = "EntityRecognizerEvaluationMetrics";
const _ERF = "EntityRecognizerFilter";
const _ERIDC = "EntityRecognizerInputDataConfig";
const _ERM = "EntityRecognizerMetadata";
const _ERMETL = "EntityRecognizerMetadataEntityTypesList";
const _ERMETLI = "EntityRecognizerMetadataEntityTypesListItem";
const _ERODC = "EntityRecognizerOutputDataConfig";
const _ERP = "EntityRecognizerProperties";
const _ERPL = "EntityRecognizerPropertiesList";
const _ERS = "EntityRecognizerSummary";
const _ERSL = "EntityRecognizerSummariesList";
const _ET = "EndTime";
const _ETEM = "EntityTypesEvaluationMetrics";
const _ETL = "EntityTypesList";
const _ETLI = "EntityTypesListItem";
const _ETn = "EntityTypes";
const _En = "Entity";
const _Er = "Errors";
const _F = "Filter";
const _FA = "FlywheelArn";
const _FF = "FlywheelFilter";
const _FIF = "FlywheelIterationFilter";
const _FII = "FlywheelIterationId";
const _FIP = "FlywheelIterationProperties";
const _FIPL = "FlywheelIterationPropertiesList";
const _FMEM = "FlywheelModelEvaluationMetrics";
const _FN = "FlywheelName";
const _FP = "FlywheelProperties";
const _FS = "F1Score";
const _FSL = "FlywheelSummaryList";
const _FSSP = "FlywheelStatsS3Prefix";
const _FSl = "FlywheelSummary";
const _FT = "FeatureTypes";
const _G = "Geometry";
const _GS = "GroupScore";
const _H = "Height";
const _HL = "HammingLoss";
const _I = "Index";
const _IDC = "InputDataConfig";
const _IF = "InputFormat";
const _IFE = "InvalidFilterException";
const _IM = "ImportModel";
const _IMR = "ImportModelRequest";
const _IMRm = "ImportModelResponse";
const _IRD = "InvalidRequestDetail";
const _IRE = "InvalidRequestException";
const _ISE = "InternalServerException";
const _Id = "Id";
const _Ids = "Ids";
const _JA = "JobArn";
const _JI = "JobId";
const _JN = "JobName";
const _JNFE = "JobNotFoundException";
const _JS = "JobStatus";
const _K = "Key";
const _KKI = "KmsKeyId";
const _KKVE = "KmsKeyValidationException";
const _KP = "KeyPhrases";
const _KPDJF = "KeyPhrasesDetectionJobFilter";
const _KPDJP = "KeyPhrasesDetectionJobProperties";
const _KPDJPL = "KeyPhrasesDetectionJobPropertiesList";
const _KPe = "KeyPhrase";
const _L = "Languages";
const _LC = "LanguageCode";
const _LD = "LabelDelimiter";
const _LDC = "ListDocumentClassifiers";
const _LDCJ = "ListDocumentClassificationJobs";
const _LDCJR = "ListDocumentClassificationJobsRequest";
const _LDCJRi = "ListDocumentClassificationJobsResponse";
const _LDCR = "ListDocumentClassifiersRequest";
const _LDCRi = "ListDocumentClassifiersResponse";
const _LDCS = "ListDocumentClassifierSummaries";
const _LDCSR = "ListDocumentClassifierSummariesRequest";
const _LDCSRi = "ListDocumentClassifierSummariesResponse";
const _LDLDJ = "ListDominantLanguageDetectionJobs";
const _LDLDJR = "ListDominantLanguageDetectionJobsRequest";
const _LDLDJRi = "ListDominantLanguageDetectionJobsResponse";
const _LDR = "ListDatasetsRequest";
const _LDRi = "ListDatasetsResponse";
const _LDi = "ListDatasets";
const _LE = "ListEndpoints";
const _LEDJ = "ListEntitiesDetectionJobs";
const _LEDJR = "ListEntitiesDetectionJobsRequest";
const _LEDJRi = "ListEntitiesDetectionJobsResponse";
const _LEDJRis = "ListEventsDetectionJobsRequest";
const _LEDJRist = "ListEventsDetectionJobsResponse";
const _LEDJi = "ListEventsDetectionJobs";
const _LER = "ListEndpointsRequest";
const _LERR = "ListEntityRecognizersRequest";
const _LERRi = "ListEntityRecognizersResponse";
const _LERS = "ListEntityRecognizerSummaries";
const _LERSR = "ListEntityRecognizerSummariesRequest";
const _LERSRi = "ListEntityRecognizerSummariesResponse";
const _LERi = "ListEndpointsResponse";
const _LERis = "ListEntityRecognizers";
const _LF = "ListFlywheels";
const _LFI = "LatestFlywheelIteration";
const _LFIH = "ListFlywheelIterationHistory";
const _LFIHR = "ListFlywheelIterationHistoryRequest";
const _LFIHRi = "ListFlywheelIterationHistoryResponse";
const _LFR = "ListFlywheelsRequest";
const _LFRi = "ListFlywheelsResponse";
const _LKPDJ = "ListKeyPhrasesDetectionJobs";
const _LKPDJR = "ListKeyPhrasesDetectionJobsRequest";
const _LKPDJRi = "ListKeyPhrasesDetectionJobsResponse";
const _LMT = "LastModifiedTime";
const _LOB = "ListOfBlocks";
const _LOBR = "ListOfBlockReferences";
const _LOC = "ListOfClasses";
const _LOCB = "ListOfChildBlocks";
const _LODDLR = "ListOfDetectDominantLanguageResult";
const _LODER = "ListOfDetectEntitiesResult";
const _LODKPR = "ListOfDetectKeyPhrasesResult";
const _LODL = "ListOfDominantLanguages";
const _LODSR = "ListOfDetectSentimentResult";
const _LODSRi = "ListOfDetectSyntaxResult";
const _LODT = "ListOfDocumentType";
const _LODTSR = "ListOfDetectTargetedSentimentResult";
const _LOE = "ListOfEntities";
const _LOEC = "ListOfExtractedCharacters";
const _LOEL = "ListOfEntityLabels";
const _LOEi = "ListOfErrors";
const _LOKP = "ListOfKeyPhrases";
const _LOL = "ListOfLabels";
const _LOM = "ListOfMentions";
const _LOPE = "ListOfPiiEntities";
const _LOR = "ListOfRelationships";
const _LOST = "ListOfSyntaxTokens";
const _LOTC = "ListOfToxicContent";
const _LOTL = "ListOfToxicLabels";
const _LOTS = "ListOfTextSegments";
const _LOTSE = "ListOfTargetedSentimentEntities";
const _LOW = "ListOfWarnings";
const _LPEDJ = "ListPiiEntitiesDetectionJobs";
const _LPEDJR = "ListPiiEntitiesDetectionJobsRequest";
const _LPEDJRi = "ListPiiEntitiesDetectionJobsResponse";
const _LSDJ = "ListSentimentDetectionJobs";
const _LSDJR = "ListSentimentDetectionJobsRequest";
const _LSDJRi = "ListSentimentDetectionJobsResponse";
const _LTDJ = "ListTopicsDetectionJobs";
const _LTDJR = "ListTopicsDetectionJobsRequest";
const _LTDJRi = "ListTopicsDetectionJobsResponse";
const _LTFR = "ListTagsForResource";
const _LTFRR = "ListTagsForResourceRequest";
const _LTFRRi = "ListTagsForResourceResponse";
const _LTSDJ = "ListTargetedSentimentDetectionJobs";
const _LTSDJR = "ListTargetedSentimentDetectionJobsRequest";
const _LTSDJRi = "ListTargetedSentimentDetectionJobsResponse";
const _LVCA = "LatestVersionCreatedAt";
const _LVN = "LatestVersionName";
const _LVS = "LatestVersionStatus";
const _La = "Labels";
const _Le = "Left";
const _M = "Message";
const _MA = "ModelArn";
const _MC = "MaskCharacter";
const _MFS = "MicroF1Score";
const _MKKI = "ModelKmsKeyId";
const _MM = "MaskMode";
const _MN = "ModelName";
const _MP = "MicroPrecision";
const _MPo = "ModelPolicy";
const _MR = "MicroRecall";
const _MRa = "MaxResults";
const _MS = "MentionSentiment";
const _MT = "ModelType";
const _Me = "Mentions";
const _Mi = "Mixed";
const _Mo = "Mode";
const _N = "Name";
const _NOD = "NumberOfDocuments";
const _NOL = "NumberOfLabels";
const _NOT = "NumberOfTopics";
const _NOTD = "NumberOfTrainedDocuments";
const _NOTDu = "NumberOfTestDocuments";
const _NOTM = "NumberOfTrainMentions";
const _NOV = "NumberOfVersions";
const _NT = "NextToken";
const _Ne = "Negative";
const _Neu = "Neutral";
const _ODC = "OutputDataConfig";
const _P = "Page";
const _PE = "PiiEntity";
const _PEDJF = "PiiEntitiesDetectionJobFilter";
const _PEDJP = "PiiEntitiesDetectionJobProperties";
const _PEDJPL = "PiiEntitiesDetectionJobPropertiesList";
const _PET = "PiiEntityTypes";
const _PODC = "PiiOutputDataConfig";
const _POS = "PartOfSpeech";
const _POST = "PartOfSpeechTag";
const _PRI = "PolicyRevisionId";
const _PRP = "PutResourcePolicy";
const _PRPR = "PutResourcePolicyRequest";
const _PRPRu = "PutResourcePolicyResponse";
const _Pa = "Pages";
const _Po = "Polygon";
const _Poi = "Point";
const _Pos = "Positive";
const _Pr = "Precision";
const _R = "Relationships";
const _RA = "ResourceArn";
const _RC = "RedactionConfig";
const _RIUE = "ResourceInUseException";
const _RL = "ResultList";
const _RLEE = "ResourceLimitExceededException";
const _RLI = "RelationshipsListItem";
const _RM = "RecognizerMetadata";
const _RN = "RecognizerName";
const _RNFE = "ResourceNotFoundException";
const _RP = "ResourcePolicy";
const _RUE = "ResourceUnavailableException";
const _Re = "Recall";
const _Rea = "Reason";
const _S = "Split";
const _SDCJ = "StartDocumentClassificationJob";
const _SDCJR = "StartDocumentClassificationJobRequest";
const _SDCJRt = "StartDocumentClassificationJobResponse";
const _SDJF = "SentimentDetectionJobFilter";
const _SDJP = "SentimentDetectionJobProperties";
const _SDJPL = "SentimentDetectionJobPropertiesList";
const _SDLDJ = "StartDominantLanguageDetectionJob";
const _SDLDJR = "StartDominantLanguageDetectionJobRequest";
const _SDLDJRt = "StartDominantLanguageDetectionJobResponse";
const _SDLDJRto = "StopDominantLanguageDetectionJobRequest";
const _SDLDJRtop = "StopDominantLanguageDetectionJobResponse";
const _SDLDJt = "StopDominantLanguageDetectionJob";
const _SDSU = "SourceDocumentsS3Uri";
const _SEDJ = "StartEntitiesDetectionJob";
const _SEDJR = "StartEntitiesDetectionJobRequest";
const _SEDJRt = "StartEntitiesDetectionJobResponse";
const _SEDJRta = "StartEventsDetectionJobRequest";
const _SEDJRtar = "StartEventsDetectionJobResponse";
const _SEDJRto = "StopEntitiesDetectionJobRequest";
const _SEDJRtop = "StopEntitiesDetectionJobResponse";
const _SEDJRtopv = "StopEventsDetectionJobRequest";
const _SEDJRtopve = "StopEventsDetectionJobResponse";
const _SEDJt = "StartEventsDetectionJob";
const _SEDJto = "StopEntitiesDetectionJob";
const _SEDJtop = "StopEventsDetectionJob";
const _SFI = "StartFlywheelIteration";
const _SFIR = "StartFlywheelIterationRequest";
const _SFIRt = "StartFlywheelIterationResponse";
const _SGI = "SecurityGroupIds";
const _SKPDJ = "StartKeyPhrasesDetectionJob";
const _SKPDJR = "StartKeyPhrasesDetectionJobRequest";
const _SKPDJRt = "StartKeyPhrasesDetectionJobResponse";
const _SKPDJRto = "StopKeyPhrasesDetectionJobRequest";
const _SKPDJRtop = "StopKeyPhrasesDetectionJobResponse";
const _SKPDJt = "StopKeyPhrasesDetectionJob";
const _SMA = "SourceModelArn";
const _SPEDJ = "StartPiiEntitiesDetectionJob";
const _SPEDJR = "StartPiiEntitiesDetectionJobRequest";
const _SPEDJRt = "StartPiiEntitiesDetectionJobResponse";
const _SPEDJRto = "StopPiiEntitiesDetectionJobRequest";
const _SPEDJRtop = "StopPiiEntitiesDetectionJobResponse";
const _SPEDJt = "StopPiiEntitiesDetectionJob";
const _SS = "SentimentScore";
const _SSDJ = "StartSentimentDetectionJob";
const _SSDJR = "StartSentimentDetectionJobRequest";
const _SSDJRt = "StartSentimentDetectionJobResponse";
const _SSDJRto = "StopSentimentDetectionJobRequest";
const _SSDJRtop = "StopSentimentDetectionJobResponse";
const _SSDJt = "StopSentimentDetectionJob";
const _ST = "SyntaxTokens";
const _STA = "SubmitTimeAfter";
const _STB = "SubmitTimeBefore";
const _STDC = "StopTrainingDocumentClassifier";
const _STDCR = "StopTrainingDocumentClassifierRequest";
const _STDCRt = "StopTrainingDocumentClassifierResponse";
const _STDJ = "StartTopicsDetectionJob";
const _STDJR = "StartTopicsDetectionJobRequest";
const _STDJRt = "StartTopicsDetectionJobResponse";
const _STER = "StopTrainingEntityRecognizer";
const _STERR = "StopTrainingEntityRecognizerRequest";
const _STERRt = "StopTrainingEntityRecognizerResponse";
const _STSDJ = "StartTargetedSentimentDetectionJob";
const _STSDJR = "StartTargetedSentimentDetectionJobRequest";
const _STSDJRt = "StartTargetedSentimentDetectionJobResponse";
const _STSDJRto = "StopTargetedSentimentDetectionJobRequest";
const _STSDJRtop = "StopTargetedSentimentDetectionJobResponse";
const _STSDJt = "StopTargetedSentimentDetectionJob";
const _STu = "SubmitTime";
const _STy = "SyntaxToken";
const _SU = "S3Uri";
const _Sc = "Score";
const _Se = "Sentiment";
const _St = "Status";
const _Su = "Subnets";
const _T = "Text";
const _TC = "TaskConfig";
const _TCo = "ToxicContent";
const _TDJF = "TopicsDetectionJobFilter";
const _TDJP = "TopicsDetectionJobProperties";
const _TDJPL = "TopicsDetectionJobPropertiesList";
const _TET = "TrainingEndTime";
const _TETa = "TargetEventTypes";
const _TI = "TokenId";
const _TK = "TagKeys";
const _TL = "TextList";
const _TLa = "TagList";
const _TLo = "ToxicLabels";
const _TMA = "TrainedModelArn";
const _TMM = "TrainedModelMetrics";
const _TMRE = "TooManyRequestsException";
const _TMTE = "TooManyTagsException";
const _TMTKE = "TooManyTagKeysException";
const _TR = "TagResource";
const _TRR = "TagResourceRequest";
const _TRRa = "TagResourceResponse";
const _TS = "TextSegments";
const _TSDJF = "TargetedSentimentDetectionJobFilter";
const _TSDJP = "TargetedSentimentDetectionJobProperties";
const _TSDJPL = "TargetedSentimentDetectionJobPropertiesList";
const _TSE = "TargetedSentimentEntity";
const _TSLEE = "TextSizeLimitExceededException";
const _TSM = "TargetedSentimentMention";
const _TST = "TrainingStartTime";
const _TSU = "TestS3Uri";
const _TSe = "TextSegment";
const _Ta = "Tags";
const _Tag = "Tag";
const _To = "Top";
const _Tox = "Toxicity";
const _Ty = "Type";
const _UDSC = "UpdateDataSecurityConfig";
const _UE = "UpdateEndpoint";
const _UER = "UpdateEndpointRequest";
const _UERp = "UpdateEndpointResponse";
const _UF = "UpdateFlywheel";
const _UFR = "UpdateFlywheelRequest";
const _UFRp = "UpdateFlywheelResponse";
const _ULE = "UnsupportedLanguageException";
const _UR = "UntagResource";
const _URR = "UntagResourceRequest";
const _URRn = "UntagResourceResponse";
const _V = "Value";
const _VC = "VpcConfig";
const _VKKI = "VolumeKmsKeyId";
const _VN = "VersionName";
const _W = "Width";
const _WC = "WarnCode";
const _WLI = "WarningsListItem";
const _WM = "WarnMessage";
const _Wa = "Warnings";
const _X = "X";
const _Y = "Y";
const _c = "client";
const _e = "error";
const _hE = "httpError";
const _s = "server";
const _sm = "smithy.ts.sdk.synthetic.com.amazonaws.comprehend";
const n0 = "com.amazonaws.comprehend";
import { TypeRegistry } from "@smithy/core/schema";
import { ComprehendServiceException as __ComprehendServiceException } from "../models/ComprehendServiceException";
import { BatchSizeLimitExceededException as __BatchSizeLimitExceededException, ConcurrentModificationException as __ConcurrentModificationException, InternalServerException as __InternalServerException, InvalidFilterException as __InvalidFilterException, InvalidRequestException as __InvalidRequestException, JobNotFoundException as __JobNotFoundException, KmsKeyValidationException as __KmsKeyValidationException, ResourceInUseException as __ResourceInUseException, ResourceLimitExceededException as __ResourceLimitExceededException, ResourceNotFoundException as __ResourceNotFoundException, ResourceUnavailableException as __ResourceUnavailableException, TextSizeLimitExceededException as __TextSizeLimitExceededException, TooManyRequestsException as __TooManyRequestsException, TooManyTagKeysException as __TooManyTagKeysException, TooManyTagsException as __TooManyTagsException, UnsupportedLanguageException as __UnsupportedLanguageException, } from "../models/index";
export var CustomerInputString = [0, n0, _CIS, 8, 0];
export var AugmentedManifestsListItem = [
    3,
    n0,
    _AMLI,
    0,
    [_SU, _S, _AN, _ADSU, _SDSU, _DT],
    [0, 0, 64 | 0, 0, 0, 0],
];
export var BatchDetectDominantLanguageItemResult = [
    3,
    n0,
    _BDDLIR,
    0,
    [_I, _L],
    [1, () => ListOfDominantLanguages],
];
export var BatchDetectDominantLanguageRequest = [
    3,
    n0,
    _BDDLR,
    0,
    [_TL],
    [[() => CustomerInputStringList, 0]],
];
export var BatchDetectDominantLanguageResponse = [
    3,
    n0,
    _BDDLRa,
    8,
    [_RL, _EL],
    [() => ListOfDetectDominantLanguageResult, () => BatchItemErrorList],
];
export var BatchDetectEntitiesItemResult = [
    3,
    n0,
    _BDEIR,
    0,
    [_I, _E],
    [1, () => ListOfEntities],
];
export var BatchDetectEntitiesRequest = [
    3,
    n0,
    _BDER,
    0,
    [_TL, _LC],
    [[() => CustomerInputStringList, 0], 0],
];
export var BatchDetectEntitiesResponse = [
    3,
    n0,
    _BDERa,
    8,
    [_RL, _EL],
    [() => ListOfDetectEntitiesResult, () => BatchItemErrorList],
];
export var BatchDetectKeyPhrasesItemResult = [
    3,
    n0,
    _BDKPIR,
    0,
    [_I, _KP],
    [1, () => ListOfKeyPhrases],
];
export var BatchDetectKeyPhrasesRequest = [
    3,
    n0,
    _BDKPR,
    0,
    [_TL, _LC],
    [[() => CustomerInputStringList, 0], 0],
];
export var BatchDetectKeyPhrasesResponse = [
    3,
    n0,
    _BDKPRa,
    8,
    [_RL, _EL],
    [() => ListOfDetectKeyPhrasesResult, () => BatchItemErrorList],
];
export var BatchDetectSentimentItemResult = [
    3,
    n0,
    _BDSIR,
    0,
    [_I, _Se, _SS],
    [1, 0, () => SentimentScore],
];
export var BatchDetectSentimentRequest = [
    3,
    n0,
    _BDSR,
    0,
    [_TL, _LC],
    [[() => CustomerInputStringList, 0], 0],
];
export var BatchDetectSentimentResponse = [
    3,
    n0,
    _BDSRa,
    8,
    [_RL, _EL],
    [() => ListOfDetectSentimentResult, () => BatchItemErrorList],
];
export var BatchDetectSyntaxItemResult = [
    3,
    n0,
    _BDSIRa,
    0,
    [_I, _ST],
    [1, () => ListOfSyntaxTokens],
];
export var BatchDetectSyntaxRequest = [
    3,
    n0,
    _BDSRat,
    0,
    [_TL, _LC],
    [[() => CustomerInputStringList, 0], 0],
];
export var BatchDetectSyntaxResponse = [
    3,
    n0,
    _BDSRatc,
    8,
    [_RL, _EL],
    [() => ListOfDetectSyntaxResult, () => BatchItemErrorList],
];
export var BatchDetectTargetedSentimentItemResult = [
    3,
    n0,
    _BDTSIR,
    0,
    [_I, _E],
    [1, () => ListOfTargetedSentimentEntities],
];
export var BatchDetectTargetedSentimentRequest = [
    3,
    n0,
    _BDTSR,
    0,
    [_TL, _LC],
    [[() => CustomerInputStringList, 0], 0],
];
export var BatchDetectTargetedSentimentResponse = [
    3,
    n0,
    _BDTSRa,
    8,
    [_RL, _EL],
    [() => ListOfDetectTargetedSentimentResult, () => BatchItemErrorList],
];
export var BatchItemError = [3, n0, _BIE, 0, [_I, _EC, _EM], [1, 0, 0]];
export var BatchSizeLimitExceededException = [
    -3,
    n0,
    _BSLEE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(BatchSizeLimitExceededException, __BatchSizeLimitExceededException);
export var Block = [
    3,
    n0,
    _B,
    0,
    [_Id, _BT, _T, _P, _G, _R],
    [0, 0, 0, 1, () => Geometry, () => ListOfRelationships],
];
export var BlockReference = [
    3,
    n0,
    _BR,
    0,
    [_BI, _BO, _EO, _CB],
    [0, 1, 1, () => ListOfChildBlocks],
];
export var BoundingBox = [3, n0, _BB, 0, [_H, _Le, _To, _W], [1, 1, 1, 1]];
export var ChildBlock = [3, n0, _CBh, 0, [_CBI, _BO, _EO], [0, 1, 1]];
export var ClassifierEvaluationMetrics = [
    3,
    n0,
    _CEM,
    0,
    [_A, _Pr, _Re, _FS, _MP, _MR, _MFS, _HL],
    [1, 1, 1, 1, 1, 1, 1, 1],
];
export var ClassifierMetadata = [
    3,
    n0,
    _CM,
    8,
    [_NOL, _NOTD, _NOTDu, _EMv],
    [1, 1, 1, () => ClassifierEvaluationMetrics],
];
export var ClassifyDocumentRequest = [
    3,
    n0,
    _CDR,
    0,
    [_T, _EA, _By, _DRC],
    [[() => CustomerInputString, 0], 0, 21, () => DocumentReaderConfig],
];
export var ClassifyDocumentResponse = [
    3,
    n0,
    _CDRl,
    8,
    [_C, _La, _DM, _DT, _Er, _Wa],
    [
        () => ListOfClasses,
        () => ListOfLabels,
        () => DocumentMetadata,
        () => ListOfDocumentType,
        () => ListOfErrors,
        () => ListOfWarnings,
    ],
];
export var ConcurrentModificationException = [
    -3,
    n0,
    _CME,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ConcurrentModificationException, __ConcurrentModificationException);
export var ContainsPiiEntitiesRequest = [3, n0, _CPER, 0, [_T, _LC], [0, 0]];
export var ContainsPiiEntitiesResponse = [3, n0, _CPERo, 0, [_La], [() => ListOfEntityLabels]];
export var CreateDatasetRequest = [
    3,
    n0,
    _CDRr,
    0,
    [_FA, _DN, _DTa, _D, _IDC, _CRT, _Ta],
    [0, 0, 0, 0, () => DatasetInputDataConfig, [0, 4], () => TagList],
];
export var CreateDatasetResponse = [3, n0, _CDRre, 0, [_DA], [0]];
export var CreateDocumentClassifierRequest = [
    3,
    n0,
    _CDCR,
    0,
    [_DCN, _VN, _DARA, _Ta, _IDC, _ODC, _CRT, _LC, _VKKI, _VC, _Mo, _MKKI, _MPo],
    [
        0,
        0,
        0,
        () => TagList,
        () => DocumentClassifierInputDataConfig,
        () => DocumentClassifierOutputDataConfig,
        [0, 4],
        0,
        0,
        () => VpcConfig,
        0,
        0,
        0,
    ],
];
export var CreateDocumentClassifierResponse = [3, n0, _CDCRr, 0, [_DCA], [0]];
export var CreateEndpointRequest = [
    3,
    n0,
    _CER,
    0,
    [_EN, _MA, _DIU, _CRT, _Ta, _DARA, _FA],
    [0, 0, 1, [0, 4], () => TagList, 0, 0],
];
export var CreateEndpointResponse = [3, n0, _CERr, 0, [_EA, _MA], [0, 0]];
export var CreateEntityRecognizerRequest = [
    3,
    n0,
    _CERR,
    0,
    [_RN, _VN, _DARA, _Ta, _IDC, _CRT, _LC, _VKKI, _VC, _MKKI, _MPo],
    [0, 0, 0, () => TagList, () => EntityRecognizerInputDataConfig, [0, 4], 0, 0, () => VpcConfig, 0, 0],
];
export var CreateEntityRecognizerResponse = [3, n0, _CERRr, 0, [_ERA], [0]];
export var CreateFlywheelRequest = [
    3,
    n0,
    _CFR,
    0,
    [_FN, _AMA, _DARA, _TC, _MT, _DLSU, _DSC, _CRT, _Ta],
    [0, 0, 0, () => TaskConfig, 0, 0, () => DataSecurityConfig, [0, 4], () => TagList],
];
export var CreateFlywheelResponse = [3, n0, _CFRr, 0, [_FA, _AMA], [0, 0]];
export var DataSecurityConfig = [
    3,
    n0,
    _DSC,
    0,
    [_MKKI, _VKKI, _DLKKI, _VC],
    [0, 0, 0, () => VpcConfig],
];
export var DatasetAugmentedManifestsListItem = [
    3,
    n0,
    _DAMLI,
    0,
    [_AN, _SU, _ADSU, _SDSU, _DT],
    [64 | 0, 0, 0, 0, 0],
];
export var DatasetDocumentClassifierInputDataConfig = [3, n0, _DDCIDC, 0, [_SU, _LD], [0, 0]];
export var DatasetEntityRecognizerAnnotations = [3, n0, _DERA, 0, [_SU], [0]];
export var DatasetEntityRecognizerDocuments = [3, n0, _DERD, 0, [_SU, _IF], [0, 0]];
export var DatasetEntityRecognizerEntityList = [3, n0, _DEREL, 0, [_SU], [0]];
export var DatasetEntityRecognizerInputDataConfig = [
    3,
    n0,
    _DERIDC,
    0,
    [_An, _Do, _ELn],
    [
        () => DatasetEntityRecognizerAnnotations,
        () => DatasetEntityRecognizerDocuments,
        () => DatasetEntityRecognizerEntityList,
    ],
];
export var DatasetFilter = [3, n0, _DF, 0, [_St, _DTa, _CTA, _CTB], [0, 0, 4, 4]];
export var DatasetInputDataConfig = [
    3,
    n0,
    _DIDC,
    0,
    [_AM, _DFa, _DCIDC, _ERIDC],
    [
        () => DatasetAugmentedManifestsList,
        0,
        () => DatasetDocumentClassifierInputDataConfig,
        () => DatasetEntityRecognizerInputDataConfig,
    ],
];
export var DatasetProperties = [
    3,
    n0,
    _DP,
    0,
    [_DA, _DN, _DTa, _DSU, _D, _St, _M, _NOD, _CT, _ET],
    [0, 0, 0, 0, 0, 0, 0, 1, 4, 4],
];
export var DeleteDocumentClassifierRequest = [3, n0, _DDCR, 0, [_DCA], [0]];
export var DeleteDocumentClassifierResponse = [3, n0, _DDCRe, 0, [], []];
export var DeleteEndpointRequest = [3, n0, _DER, 0, [_EA], [0]];
export var DeleteEndpointResponse = [3, n0, _DERe, 0, [], []];
export var DeleteEntityRecognizerRequest = [3, n0, _DERR, 0, [_ERA], [0]];
export var DeleteEntityRecognizerResponse = [3, n0, _DERRe, 0, [], []];
export var DeleteFlywheelRequest = [3, n0, _DFR, 0, [_FA], [0]];
export var DeleteFlywheelResponse = [3, n0, _DFRe, 0, [], []];
export var DeleteResourcePolicyRequest = [3, n0, _DRPR, 0, [_RA, _PRI], [0, 0]];
export var DeleteResourcePolicyResponse = [3, n0, _DRPRe, 0, [], []];
export var DescribeDatasetRequest = [3, n0, _DDR, 0, [_DA], [0]];
export var DescribeDatasetResponse = [3, n0, _DDRe, 0, [_DP], [() => DatasetProperties]];
export var DescribeDocumentClassificationJobRequest = [3, n0, _DDCJR, 0, [_JI], [0]];
export var DescribeDocumentClassificationJobResponse = [
    3,
    n0,
    _DDCJRe,
    0,
    [_DCJP],
    [() => DocumentClassificationJobProperties],
];
export var DescribeDocumentClassifierRequest = [3, n0, _DDCRes, 0, [_DCA], [0]];
export var DescribeDocumentClassifierResponse = [
    3,
    n0,
    _DDCResc,
    0,
    [_DCP],
    [[() => DocumentClassifierProperties, 0]],
];
export var DescribeDominantLanguageDetectionJobRequest = [3, n0, _DDLDJR, 0, [_JI], [0]];
export var DescribeDominantLanguageDetectionJobResponse = [
    3,
    n0,
    _DDLDJRe,
    0,
    [_DLDJP],
    [() => DominantLanguageDetectionJobProperties],
];
export var DescribeEndpointRequest = [3, n0, _DERes, 0, [_EA], [0]];
export var DescribeEndpointResponse = [3, n0, _DEResc, 0, [_EP], [() => EndpointProperties]];
export var DescribeEntitiesDetectionJobRequest = [3, n0, _DEDJR, 0, [_JI], [0]];
export var DescribeEntitiesDetectionJobResponse = [
    3,
    n0,
    _DEDJRe,
    0,
    [_EDJP],
    [() => EntitiesDetectionJobProperties],
];
export var DescribeEntityRecognizerRequest = [3, n0, _DERRes, 0, [_ERA], [0]];
export var DescribeEntityRecognizerResponse = [
    3,
    n0,
    _DERResc,
    0,
    [_ERP],
    [[() => EntityRecognizerProperties, 0]],
];
export var DescribeEventsDetectionJobRequest = [3, n0, _DEDJRes, 0, [_JI], [0]];
export var DescribeEventsDetectionJobResponse = [
    3,
    n0,
    _DEDJResc,
    0,
    [_EDJPv],
    [() => EventsDetectionJobProperties],
];
export var DescribeFlywheelIterationRequest = [3, n0, _DFIR, 0, [_FA, _FII], [0, 0]];
export var DescribeFlywheelIterationResponse = [
    3,
    n0,
    _DFIRe,
    0,
    [_FIP],
    [() => FlywheelIterationProperties],
];
export var DescribeFlywheelRequest = [3, n0, _DFRes, 0, [_FA], [0]];
export var DescribeFlywheelResponse = [3, n0, _DFResc, 0, [_FP], [() => FlywheelProperties]];
export var DescribeKeyPhrasesDetectionJobRequest = [3, n0, _DKPDJR, 0, [_JI], [0]];
export var DescribeKeyPhrasesDetectionJobResponse = [
    3,
    n0,
    _DKPDJRe,
    0,
    [_KPDJP],
    [() => KeyPhrasesDetectionJobProperties],
];
export var DescribePiiEntitiesDetectionJobRequest = [3, n0, _DPEDJR, 0, [_JI], [0]];
export var DescribePiiEntitiesDetectionJobResponse = [
    3,
    n0,
    _DPEDJRe,
    0,
    [_PEDJP],
    [() => PiiEntitiesDetectionJobProperties],
];
export var DescribeResourcePolicyRequest = [3, n0, _DRPRes, 0, [_RA], [0]];
export var DescribeResourcePolicyResponse = [
    3,
    n0,
    _DRPResc,
    0,
    [_RP, _CT, _LMT, _PRI],
    [0, 4, 4, 0],
];
export var DescribeSentimentDetectionJobRequest = [3, n0, _DSDJR, 0, [_JI], [0]];
export var DescribeSentimentDetectionJobResponse = [
    3,
    n0,
    _DSDJRe,
    0,
    [_SDJP],
    [() => SentimentDetectionJobProperties],
];
export var DescribeTargetedSentimentDetectionJobRequest = [3, n0, _DTSDJR, 0, [_JI], [0]];
export var DescribeTargetedSentimentDetectionJobResponse = [
    3,
    n0,
    _DTSDJRe,
    0,
    [_TSDJP],
    [() => TargetedSentimentDetectionJobProperties],
];
export var DescribeTopicsDetectionJobRequest = [3, n0, _DTDJR, 0, [_JI], [0]];
export var DescribeTopicsDetectionJobResponse = [
    3,
    n0,
    _DTDJRe,
    0,
    [_TDJP],
    [() => TopicsDetectionJobProperties],
];
export var DetectDominantLanguageRequest = [
    3,
    n0,
    _DDLR,
    0,
    [_T],
    [[() => CustomerInputString, 0]],
];
export var DetectDominantLanguageResponse = [
    3,
    n0,
    _DDLRe,
    8,
    [_L],
    [() => ListOfDominantLanguages],
];
export var DetectEntitiesRequest = [
    3,
    n0,
    _DERet,
    0,
    [_T, _LC, _EA, _By, _DRC],
    [[() => CustomerInputString, 0], 0, 0, 21, () => DocumentReaderConfig],
];
export var DetectEntitiesResponse = [
    3,
    n0,
    _DERete,
    8,
    [_E, _DM, _DT, _Bl, _Er],
    [() => ListOfEntities, () => DocumentMetadata, () => ListOfDocumentType, () => ListOfBlocks, () => ListOfErrors],
];
export var DetectKeyPhrasesRequest = [
    3,
    n0,
    _DKPR,
    0,
    [_T, _LC],
    [[() => CustomerInputString, 0], 0],
];
export var DetectKeyPhrasesResponse = [3, n0, _DKPRe, 8, [_KP], [() => ListOfKeyPhrases]];
export var DetectPiiEntitiesRequest = [3, n0, _DPER, 0, [_T, _LC], [0, 0]];
export var DetectPiiEntitiesResponse = [3, n0, _DPERe, 0, [_E], [() => ListOfPiiEntities]];
export var DetectSentimentRequest = [
    3,
    n0,
    _DSR,
    0,
    [_T, _LC],
    [[() => CustomerInputString, 0], 0],
];
export var DetectSentimentResponse = [3, n0, _DSRe, 8, [_Se, _SS], [0, () => SentimentScore]];
export var DetectSyntaxRequest = [
    3,
    n0,
    _DSRet,
    0,
    [_T, _LC],
    [[() => CustomerInputString, 0], 0],
];
export var DetectSyntaxResponse = [3, n0, _DSRete, 8, [_ST], [() => ListOfSyntaxTokens]];
export var DetectTargetedSentimentRequest = [
    3,
    n0,
    _DTSR,
    0,
    [_T, _LC],
    [[() => CustomerInputString, 0], 0],
];
export var DetectTargetedSentimentResponse = [
    3,
    n0,
    _DTSRe,
    8,
    [_E],
    [() => ListOfTargetedSentimentEntities],
];
export var DetectToxicContentRequest = [
    3,
    n0,
    _DTCR,
    0,
    [_TS, _LC],
    [[() => ListOfTextSegments, 0], 0],
];
export var DetectToxicContentResponse = [3, n0, _DTCRe, 0, [_RL], [() => ListOfToxicLabels]];
export var DocumentClass = [3, n0, _DC, 0, [_N, _Sc, _P], [0, 1, 1]];
export var DocumentClassificationConfig = [3, n0, _DCC, 0, [_Mo, _La], [0, 64 | 0]];
export var DocumentClassificationJobFilter = [
    3,
    n0,
    _DCJF,
    0,
    [_JN, _JS, _STB, _STA],
    [0, 0, 4, 4],
];
export var DocumentClassificationJobProperties = [
    3,
    n0,
    _DCJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _DCA, _IDC, _ODC, _DARA, _VKKI, _VC, _FA],
    [0, 0, 0, 0, 0, 4, 4, 0, () => InputDataConfig, () => OutputDataConfig, 0, 0, () => VpcConfig, 0],
];
export var DocumentClassifierDocuments = [3, n0, _DCD, 0, [_SU, _TSU], [0, 0]];
export var DocumentClassifierFilter = [3, n0, _DCF, 0, [_St, _DCN, _STB, _STA], [0, 0, 4, 4]];
export var DocumentClassifierInputDataConfig = [
    3,
    n0,
    _DCIDC,
    0,
    [_DFa, _SU, _TSU, _LD, _AM, _DT, _Do, _DRC],
    [
        0,
        0,
        0,
        0,
        () => DocumentClassifierAugmentedManifestsList,
        0,
        () => DocumentClassifierDocuments,
        () => DocumentReaderConfig,
    ],
];
export var DocumentClassifierOutputDataConfig = [
    3,
    n0,
    _DCODC,
    0,
    [_SU, _KKI, _FSSP],
    [0, 0, 0],
];
export var DocumentClassifierProperties = [
    3,
    n0,
    _DCP,
    0,
    [_DCA, _LC, _St, _M, _STu, _ET, _TST, _TET, _IDC, _ODC, _CM, _DARA, _VKKI, _VC, _Mo, _MKKI, _VN, _SMA, _FA],
    [
        0,
        0,
        0,
        0,
        4,
        4,
        4,
        4,
        () => DocumentClassifierInputDataConfig,
        () => DocumentClassifierOutputDataConfig,
        [() => ClassifierMetadata, 0],
        0,
        0,
        () => VpcConfig,
        0,
        0,
        0,
        0,
        0,
    ],
];
export var DocumentClassifierSummary = [
    3,
    n0,
    _DCS,
    0,
    [_DCN, _NOV, _LVCA, _LVN, _LVS],
    [0, 1, 4, 0, 0],
];
export var DocumentLabel = [3, n0, _DL, 0, [_N, _Sc, _P], [0, 1, 1]];
export var DocumentMetadata = [3, n0, _DM, 0, [_Pa, _ECx], [1, () => ListOfExtractedCharacters]];
export var DocumentReaderConfig = [3, n0, _DRC, 0, [_DRA, _DRM, _FT], [0, 0, 64 | 0]];
export var DocumentTypeListItem = [3, n0, _DTLI, 0, [_P, _Ty], [1, 0]];
export var DominantLanguage = [3, n0, _DLo, 0, [_LC, _Sc], [0, 1]];
export var DominantLanguageDetectionJobFilter = [
    3,
    n0,
    _DLDJF,
    0,
    [_JN, _JS, _STB, _STA],
    [0, 0, 4, 4],
];
export var DominantLanguageDetectionJobProperties = [
    3,
    n0,
    _DLDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _DARA, _VKKI, _VC],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => OutputDataConfig, 0, 0, () => VpcConfig],
];
export var EndpointFilter = [3, n0, _EF, 0, [_MA, _St, _CTB, _CTA], [0, 0, 4, 4]];
export var EndpointProperties = [
    3,
    n0,
    _EP,
    0,
    [_EA, _St, _M, _MA, _DMA, _DIU, _CIU, _CT, _LMT, _DARA, _DDARA, _FA],
    [0, 0, 0, 0, 0, 1, 1, 4, 4, 0, 0, 0],
];
export var EntitiesDetectionJobFilter = [3, n0, _EDJF, 0, [_JN, _JS, _STB, _STA], [0, 0, 4, 4]];
export var EntitiesDetectionJobProperties = [
    3,
    n0,
    _EDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _ERA, _IDC, _ODC, _LC, _DARA, _VKKI, _VC, _FA],
    [0, 0, 0, 0, 0, 4, 4, 0, () => InputDataConfig, () => OutputDataConfig, 0, 0, 0, () => VpcConfig, 0],
];
export var Entity = [
    3,
    n0,
    _En,
    0,
    [_Sc, _Ty, _T, _BO, _EO, _BRl],
    [1, 0, 0, 1, 1, () => ListOfBlockReferences],
];
export var EntityLabel = [3, n0, _ELnt, 0, [_N, _Sc], [0, 1]];
export var EntityRecognitionConfig = [3, n0, _ERC, 0, [_ETn], [() => EntityTypesList]];
export var EntityRecognizerAnnotations = [3, n0, _ERAn, 0, [_SU, _TSU], [0, 0]];
export var EntityRecognizerDocuments = [3, n0, _ERD, 0, [_SU, _TSU, _IF], [0, 0, 0]];
export var EntityRecognizerEntityList = [3, n0, _EREL, 0, [_SU], [0]];
export var EntityRecognizerEvaluationMetrics = [3, n0, _EREM, 0, [_Pr, _Re, _FS], [1, 1, 1]];
export var EntityRecognizerFilter = [3, n0, _ERF, 0, [_St, _RN, _STB, _STA], [0, 0, 4, 4]];
export var EntityRecognizerInputDataConfig = [
    3,
    n0,
    _ERIDC,
    0,
    [_DFa, _ETn, _Do, _An, _ELn, _AM],
    [
        0,
        () => EntityTypesList,
        () => EntityRecognizerDocuments,
        () => EntityRecognizerAnnotations,
        () => EntityRecognizerEntityList,
        () => EntityRecognizerAugmentedManifestsList,
    ],
];
export var EntityRecognizerMetadata = [
    3,
    n0,
    _ERM,
    8,
    [_NOTD, _NOTDu, _EMv, _ETn],
    [1, 1, () => EntityRecognizerEvaluationMetrics, () => EntityRecognizerMetadataEntityTypesList],
];
export var EntityRecognizerMetadataEntityTypesListItem = [
    3,
    n0,
    _ERMETLI,
    0,
    [_Ty, _EMv, _NOTM],
    [0, () => EntityTypesEvaluationMetrics, 1],
];
export var EntityRecognizerOutputDataConfig = [3, n0, _ERODC, 0, [_FSSP], [0]];
export var EntityRecognizerProperties = [
    3,
    n0,
    _ERP,
    0,
    [_ERA, _LC, _St, _M, _STu, _ET, _TST, _TET, _IDC, _RM, _DARA, _VKKI, _VC, _MKKI, _VN, _SMA, _FA, _ODC],
    [
        0,
        0,
        0,
        0,
        4,
        4,
        4,
        4,
        () => EntityRecognizerInputDataConfig,
        [() => EntityRecognizerMetadata, 0],
        0,
        0,
        () => VpcConfig,
        0,
        0,
        0,
        0,
        () => EntityRecognizerOutputDataConfig,
    ],
];
export var EntityRecognizerSummary = [
    3,
    n0,
    _ERS,
    0,
    [_RN, _NOV, _LVCA, _LVN, _LVS],
    [0, 1, 4, 0, 0],
];
export var EntityTypesEvaluationMetrics = [3, n0, _ETEM, 0, [_Pr, _Re, _FS], [1, 1, 1]];
export var EntityTypesListItem = [3, n0, _ETLI, 0, [_Ty], [0]];
export var ErrorsListItem = [3, n0, _ELI, 0, [_P, _EC, _EM], [1, 0, 0]];
export var EventsDetectionJobFilter = [3, n0, _EDJFv, 0, [_JN, _JS, _STB, _STA], [0, 0, 4, 4]];
export var EventsDetectionJobProperties = [
    3,
    n0,
    _EDJPv,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _LC, _DARA, _TETa],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => OutputDataConfig, 0, 0, 64 | 0],
];
export var ExtractedCharactersListItem = [3, n0, _ECLI, 0, [_P, _Co], [1, 1]];
export var FlywheelFilter = [3, n0, _FF, 0, [_St, _CTA, _CTB], [0, 4, 4]];
export var FlywheelIterationFilter = [3, n0, _FIF, 0, [_CTA, _CTB], [4, 4]];
export var FlywheelIterationProperties = [
    3,
    n0,
    _FIP,
    0,
    [_FA, _FII, _CT, _ET, _St, _M, _EMA, _EMM, _TMA, _TMM, _EMSP],
    [0, 0, 4, 4, 0, 0, 0, () => FlywheelModelEvaluationMetrics, 0, () => FlywheelModelEvaluationMetrics, 0],
];
export var FlywheelModelEvaluationMetrics = [
    3,
    n0,
    _FMEM,
    0,
    [_AFS, _AP, _AR, _AA],
    [1, 1, 1, 1],
];
export var FlywheelProperties = [
    3,
    n0,
    _FP,
    0,
    [_FA, _AMA, _DARA, _TC, _DLSU, _DSC, _St, _MT, _M, _CT, _LMT, _LFI],
    [0, 0, 0, () => TaskConfig, 0, () => DataSecurityConfig, 0, 0, 0, 4, 4, 0],
];
export var FlywheelSummary = [
    3,
    n0,
    _FSl,
    0,
    [_FA, _AMA, _DLSU, _St, _MT, _M, _CT, _LMT, _LFI],
    [0, 0, 0, 0, 0, 0, 4, 4, 0],
];
export var Geometry = [3, n0, _G, 0, [_BB, _Po], [() => BoundingBox, () => Polygon]];
export var ImportModelRequest = [
    3,
    n0,
    _IMR,
    0,
    [_SMA, _MN, _VN, _MKKI, _DARA, _Ta],
    [0, 0, 0, 0, 0, () => TagList],
];
export var ImportModelResponse = [3, n0, _IMRm, 0, [_MA], [0]];
export var InputDataConfig = [
    3,
    n0,
    _IDC,
    0,
    [_SU, _IF, _DRC],
    [0, 0, () => DocumentReaderConfig],
];
export var InternalServerException = [
    -3,
    n0,
    _ISE,
    {
        [_e]: _s,
        [_hE]: 500,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(InternalServerException, __InternalServerException);
export var InvalidFilterException = [
    -3,
    n0,
    _IFE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(InvalidFilterException, __InvalidFilterException);
export var InvalidRequestDetail = [3, n0, _IRD, 0, [_Rea], [0]];
export var InvalidRequestException = [
    -3,
    n0,
    _IRE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M, _Rea, _De],
    [0, 0, () => InvalidRequestDetail],
];
TypeRegistry.for(n0).registerError(InvalidRequestException, __InvalidRequestException);
export var JobNotFoundException = [
    -3,
    n0,
    _JNFE,
    {
        [_e]: _c,
        [_hE]: 404,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(JobNotFoundException, __JobNotFoundException);
export var KeyPhrase = [3, n0, _KPe, 0, [_Sc, _T, _BO, _EO], [1, 0, 1, 1]];
export var KeyPhrasesDetectionJobFilter = [
    3,
    n0,
    _KPDJF,
    0,
    [_JN, _JS, _STB, _STA],
    [0, 0, 4, 4],
];
export var KeyPhrasesDetectionJobProperties = [
    3,
    n0,
    _KPDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _LC, _DARA, _VKKI, _VC],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => OutputDataConfig, 0, 0, 0, () => VpcConfig],
];
export var KmsKeyValidationException = [
    -3,
    n0,
    _KKVE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(KmsKeyValidationException, __KmsKeyValidationException);
export var ListDatasetsRequest = [
    3,
    n0,
    _LDR,
    0,
    [_FA, _F, _NT, _MRa],
    [0, () => DatasetFilter, 0, 1],
];
export var ListDatasetsResponse = [
    3,
    n0,
    _LDRi,
    0,
    [_DPL, _NT],
    [() => DatasetPropertiesList, 0],
];
export var ListDocumentClassificationJobsRequest = [
    3,
    n0,
    _LDCJR,
    0,
    [_F, _NT, _MRa],
    [() => DocumentClassificationJobFilter, 0, 1],
];
export var ListDocumentClassificationJobsResponse = [
    3,
    n0,
    _LDCJRi,
    0,
    [_DCJPL, _NT],
    [() => DocumentClassificationJobPropertiesList, 0],
];
export var ListDocumentClassifiersRequest = [
    3,
    n0,
    _LDCR,
    0,
    [_F, _NT, _MRa],
    [() => DocumentClassifierFilter, 0, 1],
];
export var ListDocumentClassifiersResponse = [
    3,
    n0,
    _LDCRi,
    0,
    [_DCPL, _NT],
    [[() => DocumentClassifierPropertiesList, 0], 0],
];
export var ListDocumentClassifierSummariesRequest = [3, n0, _LDCSR, 0, [_NT, _MRa], [0, 1]];
export var ListDocumentClassifierSummariesResponse = [
    3,
    n0,
    _LDCSRi,
    0,
    [_DCSL, _NT],
    [() => DocumentClassifierSummariesList, 0],
];
export var ListDominantLanguageDetectionJobsRequest = [
    3,
    n0,
    _LDLDJR,
    0,
    [_F, _NT, _MRa],
    [() => DominantLanguageDetectionJobFilter, 0, 1],
];
export var ListDominantLanguageDetectionJobsResponse = [
    3,
    n0,
    _LDLDJRi,
    0,
    [_DLDJPL, _NT],
    [() => DominantLanguageDetectionJobPropertiesList, 0],
];
export var ListEndpointsRequest = [
    3,
    n0,
    _LER,
    0,
    [_F, _NT, _MRa],
    [() => EndpointFilter, 0, 1],
];
export var ListEndpointsResponse = [
    3,
    n0,
    _LERi,
    0,
    [_EPL, _NT],
    [() => EndpointPropertiesList, 0],
];
export var ListEntitiesDetectionJobsRequest = [
    3,
    n0,
    _LEDJR,
    0,
    [_F, _NT, _MRa],
    [() => EntitiesDetectionJobFilter, 0, 1],
];
export var ListEntitiesDetectionJobsResponse = [
    3,
    n0,
    _LEDJRi,
    0,
    [_EDJPL, _NT],
    [() => EntitiesDetectionJobPropertiesList, 0],
];
export var ListEntityRecognizersRequest = [
    3,
    n0,
    _LERR,
    0,
    [_F, _NT, _MRa],
    [() => EntityRecognizerFilter, 0, 1],
];
export var ListEntityRecognizersResponse = [
    3,
    n0,
    _LERRi,
    0,
    [_ERPL, _NT],
    [[() => EntityRecognizerPropertiesList, 0], 0],
];
export var ListEntityRecognizerSummariesRequest = [3, n0, _LERSR, 0, [_NT, _MRa], [0, 1]];
export var ListEntityRecognizerSummariesResponse = [
    3,
    n0,
    _LERSRi,
    0,
    [_ERSL, _NT],
    [() => EntityRecognizerSummariesList, 0],
];
export var ListEventsDetectionJobsRequest = [
    3,
    n0,
    _LEDJRis,
    0,
    [_F, _NT, _MRa],
    [() => EventsDetectionJobFilter, 0, 1],
];
export var ListEventsDetectionJobsResponse = [
    3,
    n0,
    _LEDJRist,
    0,
    [_EDJPLv, _NT],
    [() => EventsDetectionJobPropertiesList, 0],
];
export var ListFlywheelIterationHistoryRequest = [
    3,
    n0,
    _LFIHR,
    0,
    [_FA, _F, _NT, _MRa],
    [0, () => FlywheelIterationFilter, 0, 1],
];
export var ListFlywheelIterationHistoryResponse = [
    3,
    n0,
    _LFIHRi,
    0,
    [_FIPL, _NT],
    [() => FlywheelIterationPropertiesList, 0],
];
export var ListFlywheelsRequest = [
    3,
    n0,
    _LFR,
    0,
    [_F, _NT, _MRa],
    [() => FlywheelFilter, 0, 1],
];
export var ListFlywheelsResponse = [
    3,
    n0,
    _LFRi,
    0,
    [_FSL, _NT],
    [() => FlywheelSummaryList, 0],
];
export var ListKeyPhrasesDetectionJobsRequest = [
    3,
    n0,
    _LKPDJR,
    0,
    [_F, _NT, _MRa],
    [() => KeyPhrasesDetectionJobFilter, 0, 1],
];
export var ListKeyPhrasesDetectionJobsResponse = [
    3,
    n0,
    _LKPDJRi,
    0,
    [_KPDJPL, _NT],
    [() => KeyPhrasesDetectionJobPropertiesList, 0],
];
export var ListPiiEntitiesDetectionJobsRequest = [
    3,
    n0,
    _LPEDJR,
    0,
    [_F, _NT, _MRa],
    [() => PiiEntitiesDetectionJobFilter, 0, 1],
];
export var ListPiiEntitiesDetectionJobsResponse = [
    3,
    n0,
    _LPEDJRi,
    0,
    [_PEDJPL, _NT],
    [() => PiiEntitiesDetectionJobPropertiesList, 0],
];
export var ListSentimentDetectionJobsRequest = [
    3,
    n0,
    _LSDJR,
    0,
    [_F, _NT, _MRa],
    [() => SentimentDetectionJobFilter, 0, 1],
];
export var ListSentimentDetectionJobsResponse = [
    3,
    n0,
    _LSDJRi,
    0,
    [_SDJPL, _NT],
    [() => SentimentDetectionJobPropertiesList, 0],
];
export var ListTagsForResourceRequest = [3, n0, _LTFRR, 0, [_RA], [0]];
export var ListTagsForResourceResponse = [3, n0, _LTFRRi, 0, [_RA, _Ta], [0, () => TagList]];
export var ListTargetedSentimentDetectionJobsRequest = [
    3,
    n0,
    _LTSDJR,
    0,
    [_F, _NT, _MRa],
    [() => TargetedSentimentDetectionJobFilter, 0, 1],
];
export var ListTargetedSentimentDetectionJobsResponse = [
    3,
    n0,
    _LTSDJRi,
    0,
    [_TSDJPL, _NT],
    [() => TargetedSentimentDetectionJobPropertiesList, 0],
];
export var ListTopicsDetectionJobsRequest = [
    3,
    n0,
    _LTDJR,
    0,
    [_F, _NT, _MRa],
    [() => TopicsDetectionJobFilter, 0, 1],
];
export var ListTopicsDetectionJobsResponse = [
    3,
    n0,
    _LTDJRi,
    0,
    [_TDJPL, _NT],
    [() => TopicsDetectionJobPropertiesList, 0],
];
export var MentionSentiment = [3, n0, _MS, 0, [_Se, _SS], [0, () => SentimentScore]];
export var OutputDataConfig = [3, n0, _ODC, 0, [_SU, _KKI], [0, 0]];
export var PartOfSpeechTag = [3, n0, _POST, 0, [_Tag, _Sc], [0, 1]];
export var PiiEntitiesDetectionJobFilter = [
    3,
    n0,
    _PEDJF,
    0,
    [_JN, _JS, _STB, _STA],
    [0, 0, 4, 4],
];
export var PiiEntitiesDetectionJobProperties = [
    3,
    n0,
    _PEDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _RC, _LC, _DARA, _Mo],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => PiiOutputDataConfig, () => RedactionConfig, 0, 0, 0],
];
export var PiiEntity = [3, n0, _PE, 0, [_Sc, _Ty, _BO, _EO], [1, 0, 1, 1]];
export var PiiOutputDataConfig = [3, n0, _PODC, 0, [_SU, _KKI], [0, 0]];
export var Point = [3, n0, _Poi, 0, [_X, _Y], [1, 1]];
export var PutResourcePolicyRequest = [3, n0, _PRPR, 0, [_RA, _RP, _PRI], [0, 0, 0]];
export var PutResourcePolicyResponse = [3, n0, _PRPRu, 0, [_PRI], [0]];
export var RedactionConfig = [3, n0, _RC, 0, [_PET, _MM, _MC], [64 | 0, 0, 0]];
export var RelationshipsListItem = [3, n0, _RLI, 0, [_Ids, _Ty], [64 | 0, 0]];
export var ResourceInUseException = [
    -3,
    n0,
    _RIUE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ResourceInUseException, __ResourceInUseException);
export var ResourceLimitExceededException = [
    -3,
    n0,
    _RLEE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ResourceLimitExceededException, __ResourceLimitExceededException);
export var ResourceNotFoundException = [
    -3,
    n0,
    _RNFE,
    {
        [_e]: _c,
        [_hE]: 404,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ResourceNotFoundException, __ResourceNotFoundException);
export var ResourceUnavailableException = [
    -3,
    n0,
    _RUE,
    {
        [_e]: _c,
        [_hE]: 404,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(ResourceUnavailableException, __ResourceUnavailableException);
export var SentimentDetectionJobFilter = [3, n0, _SDJF, 0, [_JN, _JS, _STB, _STA], [0, 0, 4, 4]];
export var SentimentDetectionJobProperties = [
    3,
    n0,
    _SDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _LC, _DARA, _VKKI, _VC],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => OutputDataConfig, 0, 0, 0, () => VpcConfig],
];
export var SentimentScore = [3, n0, _SS, 0, [_Pos, _Ne, _Neu, _Mi], [1, 1, 1, 1]];
export var StartDocumentClassificationJobRequest = [
    3,
    n0,
    _SDCJR,
    0,
    [_JN, _DCA, _IDC, _ODC, _DARA, _CRT, _VKKI, _VC, _Ta, _FA],
    [0, 0, () => InputDataConfig, () => OutputDataConfig, 0, [0, 4], 0, () => VpcConfig, () => TagList, 0],
];
export var StartDocumentClassificationJobResponse = [
    3,
    n0,
    _SDCJRt,
    0,
    [_JI, _JA, _JS, _DCA],
    [0, 0, 0, 0],
];
export var StartDominantLanguageDetectionJobRequest = [
    3,
    n0,
    _SDLDJR,
    0,
    [_IDC, _ODC, _DARA, _JN, _CRT, _VKKI, _VC, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, [0, 4], 0, () => VpcConfig, () => TagList],
];
export var StartDominantLanguageDetectionJobResponse = [
    3,
    n0,
    _SDLDJRt,
    0,
    [_JI, _JA, _JS],
    [0, 0, 0],
];
export var StartEntitiesDetectionJobRequest = [
    3,
    n0,
    _SEDJR,
    0,
    [_IDC, _ODC, _DARA, _JN, _ERA, _LC, _CRT, _VKKI, _VC, _Ta, _FA],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, 0, 0, [0, 4], 0, () => VpcConfig, () => TagList, 0],
];
export var StartEntitiesDetectionJobResponse = [
    3,
    n0,
    _SEDJRt,
    0,
    [_JI, _JA, _JS, _ERA],
    [0, 0, 0, 0],
];
export var StartEventsDetectionJobRequest = [
    3,
    n0,
    _SEDJRta,
    0,
    [_IDC, _ODC, _DARA, _JN, _LC, _CRT, _TETa, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, 0, [0, 4], 64 | 0, () => TagList],
];
export var StartEventsDetectionJobResponse = [3, n0, _SEDJRtar, 0, [_JI, _JA, _JS], [0, 0, 0]];
export var StartFlywheelIterationRequest = [3, n0, _SFIR, 0, [_FA, _CRT], [0, 0]];
export var StartFlywheelIterationResponse = [3, n0, _SFIRt, 0, [_FA, _FII], [0, 0]];
export var StartKeyPhrasesDetectionJobRequest = [
    3,
    n0,
    _SKPDJR,
    0,
    [_IDC, _ODC, _DARA, _JN, _LC, _CRT, _VKKI, _VC, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, 0, [0, 4], 0, () => VpcConfig, () => TagList],
];
export var StartKeyPhrasesDetectionJobResponse = [
    3,
    n0,
    _SKPDJRt,
    0,
    [_JI, _JA, _JS],
    [0, 0, 0],
];
export var StartPiiEntitiesDetectionJobRequest = [
    3,
    n0,
    _SPEDJR,
    0,
    [_IDC, _ODC, _Mo, _RC, _DARA, _JN, _LC, _CRT, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, () => RedactionConfig, 0, 0, 0, [0, 4], () => TagList],
];
export var StartPiiEntitiesDetectionJobResponse = [
    3,
    n0,
    _SPEDJRt,
    0,
    [_JI, _JA, _JS],
    [0, 0, 0],
];
export var StartSentimentDetectionJobRequest = [
    3,
    n0,
    _SSDJR,
    0,
    [_IDC, _ODC, _DARA, _JN, _LC, _CRT, _VKKI, _VC, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, 0, [0, 4], 0, () => VpcConfig, () => TagList],
];
export var StartSentimentDetectionJobResponse = [3, n0, _SSDJRt, 0, [_JI, _JA, _JS], [0, 0, 0]];
export var StartTargetedSentimentDetectionJobRequest = [
    3,
    n0,
    _STSDJR,
    0,
    [_IDC, _ODC, _DARA, _JN, _LC, _CRT, _VKKI, _VC, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, 0, [0, 4], 0, () => VpcConfig, () => TagList],
];
export var StartTargetedSentimentDetectionJobResponse = [
    3,
    n0,
    _STSDJRt,
    0,
    [_JI, _JA, _JS],
    [0, 0, 0],
];
export var StartTopicsDetectionJobRequest = [
    3,
    n0,
    _STDJR,
    0,
    [_IDC, _ODC, _DARA, _JN, _NOT, _CRT, _VKKI, _VC, _Ta],
    [() => InputDataConfig, () => OutputDataConfig, 0, 0, 1, [0, 4], 0, () => VpcConfig, () => TagList],
];
export var StartTopicsDetectionJobResponse = [3, n0, _STDJRt, 0, [_JI, _JA, _JS], [0, 0, 0]];
export var StopDominantLanguageDetectionJobRequest = [3, n0, _SDLDJRto, 0, [_JI], [0]];
export var StopDominantLanguageDetectionJobResponse = [3, n0, _SDLDJRtop, 0, [_JI, _JS], [0, 0]];
export var StopEntitiesDetectionJobRequest = [3, n0, _SEDJRto, 0, [_JI], [0]];
export var StopEntitiesDetectionJobResponse = [3, n0, _SEDJRtop, 0, [_JI, _JS], [0, 0]];
export var StopEventsDetectionJobRequest = [3, n0, _SEDJRtopv, 0, [_JI], [0]];
export var StopEventsDetectionJobResponse = [3, n0, _SEDJRtopve, 0, [_JI, _JS], [0, 0]];
export var StopKeyPhrasesDetectionJobRequest = [3, n0, _SKPDJRto, 0, [_JI], [0]];
export var StopKeyPhrasesDetectionJobResponse = [3, n0, _SKPDJRtop, 0, [_JI, _JS], [0, 0]];
export var StopPiiEntitiesDetectionJobRequest = [3, n0, _SPEDJRto, 0, [_JI], [0]];
export var StopPiiEntitiesDetectionJobResponse = [3, n0, _SPEDJRtop, 0, [_JI, _JS], [0, 0]];
export var StopSentimentDetectionJobRequest = [3, n0, _SSDJRto, 0, [_JI], [0]];
export var StopSentimentDetectionJobResponse = [3, n0, _SSDJRtop, 0, [_JI, _JS], [0, 0]];
export var StopTargetedSentimentDetectionJobRequest = [3, n0, _STSDJRto, 0, [_JI], [0]];
export var StopTargetedSentimentDetectionJobResponse = [
    3,
    n0,
    _STSDJRtop,
    0,
    [_JI, _JS],
    [0, 0],
];
export var StopTrainingDocumentClassifierRequest = [3, n0, _STDCR, 0, [_DCA], [0]];
export var StopTrainingDocumentClassifierResponse = [3, n0, _STDCRt, 0, [], []];
export var StopTrainingEntityRecognizerRequest = [3, n0, _STERR, 0, [_ERA], [0]];
export var StopTrainingEntityRecognizerResponse = [3, n0, _STERRt, 0, [], []];
export var SyntaxToken = [
    3,
    n0,
    _STy,
    0,
    [_TI, _T, _BO, _EO, _POS],
    [1, 0, 1, 1, () => PartOfSpeechTag],
];
export var Tag = [3, n0, _Tag, 0, [_K, _V], [0, 0]];
export var TagResourceRequest = [3, n0, _TRR, 0, [_RA, _Ta], [0, () => TagList]];
export var TagResourceResponse = [3, n0, _TRRa, 0, [], []];
export var TargetedSentimentDetectionJobFilter = [
    3,
    n0,
    _TSDJF,
    0,
    [_JN, _JS, _STB, _STA],
    [0, 0, 4, 4],
];
export var TargetedSentimentDetectionJobProperties = [
    3,
    n0,
    _TSDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _LC, _DARA, _VKKI, _VC],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => OutputDataConfig, 0, 0, 0, () => VpcConfig],
];
export var TargetedSentimentEntity = [
    3,
    n0,
    _TSE,
    0,
    [_DMI, _Me],
    [64 | 1, () => ListOfMentions],
];
export var TargetedSentimentMention = [
    3,
    n0,
    _TSM,
    0,
    [_Sc, _GS, _T, _Ty, _MS, _BO, _EO],
    [1, 1, 0, 0, () => MentionSentiment, 1, 1],
];
export var TaskConfig = [
    3,
    n0,
    _TC,
    0,
    [_LC, _DCC, _ERC],
    [0, () => DocumentClassificationConfig, () => EntityRecognitionConfig],
];
export var TextSegment = [3, n0, _TSe, 0, [_T], [[() => CustomerInputString, 0]]];
export var TextSizeLimitExceededException = [
    -3,
    n0,
    _TSLEE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(TextSizeLimitExceededException, __TextSizeLimitExceededException);
export var TooManyRequestsException = [
    -3,
    n0,
    _TMRE,
    {
        [_e]: _c,
        [_hE]: 429,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(TooManyRequestsException, __TooManyRequestsException);
export var TooManyTagKeysException = [
    -3,
    n0,
    _TMTKE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(TooManyTagKeysException, __TooManyTagKeysException);
export var TooManyTagsException = [
    -3,
    n0,
    _TMTE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(TooManyTagsException, __TooManyTagsException);
export var TopicsDetectionJobFilter = [3, n0, _TDJF, 0, [_JN, _JS, _STB, _STA], [0, 0, 4, 4]];
export var TopicsDetectionJobProperties = [
    3,
    n0,
    _TDJP,
    0,
    [_JI, _JA, _JN, _JS, _M, _STu, _ET, _IDC, _ODC, _NOT, _DARA, _VKKI, _VC],
    [0, 0, 0, 0, 0, 4, 4, () => InputDataConfig, () => OutputDataConfig, 1, 0, 0, () => VpcConfig],
];
export var ToxicContent = [3, n0, _TCo, 0, [_N, _Sc], [0, 1]];
export var ToxicLabels = [3, n0, _TLo, 0, [_La, _Tox], [() => ListOfToxicContent, 1]];
export var UnsupportedLanguageException = [
    -3,
    n0,
    _ULE,
    {
        [_e]: _c,
        [_hE]: 400,
    },
    [_M],
    [0],
];
TypeRegistry.for(n0).registerError(UnsupportedLanguageException, __UnsupportedLanguageException);
export var UntagResourceRequest = [3, n0, _URR, 0, [_RA, _TK], [0, 64 | 0]];
export var UntagResourceResponse = [3, n0, _URRn, 0, [], []];
export var UpdateDataSecurityConfig = [
    3,
    n0,
    _UDSC,
    0,
    [_MKKI, _VKKI, _VC],
    [0, 0, () => VpcConfig],
];
export var UpdateEndpointRequest = [
    3,
    n0,
    _UER,
    0,
    [_EA, _DMA, _DIU, _DDARA, _FA],
    [0, 0, 1, 0, 0],
];
export var UpdateEndpointResponse = [3, n0, _UERp, 0, [_DMA], [0]];
export var UpdateFlywheelRequest = [
    3,
    n0,
    _UFR,
    0,
    [_FA, _AMA, _DARA, _DSC],
    [0, 0, 0, () => UpdateDataSecurityConfig],
];
export var UpdateFlywheelResponse = [3, n0, _UFRp, 0, [_FP], [() => FlywheelProperties]];
export var VpcConfig = [3, n0, _VC, 0, [_SGI, _Su], [64 | 0, 64 | 0]];
export var WarningsListItem = [3, n0, _WLI, 0, [_P, _WC, _WM], [1, 0, 0]];
export var __Unit = "unit";
export var ComprehendServiceException = [-3, _sm, "ComprehendServiceException", 0, [], []];
TypeRegistry.for(_sm).registerError(ComprehendServiceException, __ComprehendServiceException);
export var AttributeNamesList = 64 | 0;
export var BatchItemErrorList = [1, n0, _BIEL, 0, () => BatchItemError];
export var CustomerInputStringList = [1, n0, _CISL, 8, [() => CustomerInputString, 0]];
export var DatasetAugmentedManifestsList = [1, n0, _DAML, 0, () => DatasetAugmentedManifestsListItem];
export var DatasetPropertiesList = [1, n0, _DPL, 0, () => DatasetProperties];
export var DocumentClassificationJobPropertiesList = [
    1,
    n0,
    _DCJPL,
    0,
    () => DocumentClassificationJobProperties,
];
export var DocumentClassifierAugmentedManifestsList = [
    1,
    n0,
    _DCAML,
    0,
    () => AugmentedManifestsListItem,
];
export var DocumentClassifierPropertiesList = [
    1,
    n0,
    _DCPL,
    0,
    [() => DocumentClassifierProperties, 0],
];
export var DocumentClassifierSummariesList = [1, n0, _DCSL, 0, () => DocumentClassifierSummary];
export var DominantLanguageDetectionJobPropertiesList = [
    1,
    n0,
    _DLDJPL,
    0,
    () => DominantLanguageDetectionJobProperties,
];
export var EndpointPropertiesList = [1, n0, _EPL, 0, () => EndpointProperties];
export var EntitiesDetectionJobPropertiesList = [
    1,
    n0,
    _EDJPL,
    0,
    () => EntitiesDetectionJobProperties,
];
export var EntityRecognizerAugmentedManifestsList = [
    1,
    n0,
    _ERAML,
    0,
    () => AugmentedManifestsListItem,
];
export var EntityRecognizerMetadataEntityTypesList = [
    1,
    n0,
    _ERMETL,
    0,
    () => EntityRecognizerMetadataEntityTypesListItem,
];
export var EntityRecognizerPropertiesList = [1, n0, _ERPL, 0, [() => EntityRecognizerProperties, 0]];
export var EntityRecognizerSummariesList = [1, n0, _ERSL, 0, () => EntityRecognizerSummary];
export var EntityTypesList = [1, n0, _ETL, 0, () => EntityTypesListItem];
export var EventsDetectionJobPropertiesList = [1, n0, _EDJPLv, 0, () => EventsDetectionJobProperties];
export var FlywheelIterationPropertiesList = [1, n0, _FIPL, 0, () => FlywheelIterationProperties];
export var FlywheelSummaryList = [1, n0, _FSL, 0, () => FlywheelSummary];
export var KeyPhrasesDetectionJobPropertiesList = [
    1,
    n0,
    _KPDJPL,
    0,
    () => KeyPhrasesDetectionJobProperties,
];
export var LabelsList = 64 | 0;
export var ListOfBlockReferences = [1, n0, _LOBR, 0, () => BlockReference];
export var ListOfBlocks = [1, n0, _LOB, 0, () => Block];
export var ListOfChildBlocks = [1, n0, _LOCB, 0, () => ChildBlock];
export var ListOfClasses = [1, n0, _LOC, 0, () => DocumentClass];
export var ListOfDescriptiveMentionIndices = 64 | 1;
export var ListOfDetectDominantLanguageResult = [
    1,
    n0,
    _LODDLR,
    0,
    () => BatchDetectDominantLanguageItemResult,
];
export var ListOfDetectEntitiesResult = [1, n0, _LODER, 0, () => BatchDetectEntitiesItemResult];
export var ListOfDetectKeyPhrasesResult = [1, n0, _LODKPR, 0, () => BatchDetectKeyPhrasesItemResult];
export var ListOfDetectSentimentResult = [1, n0, _LODSR, 0, () => BatchDetectSentimentItemResult];
export var ListOfDetectSyntaxResult = [1, n0, _LODSRi, 0, () => BatchDetectSyntaxItemResult];
export var ListOfDetectTargetedSentimentResult = [
    1,
    n0,
    _LODTSR,
    0,
    () => BatchDetectTargetedSentimentItemResult,
];
export var ListOfDocumentReadFeatureTypes = 64 | 0;
export var ListOfDocumentType = [1, n0, _LODT, 0, () => DocumentTypeListItem];
export var ListOfDominantLanguages = [1, n0, _LODL, 0, () => DominantLanguage];
export var ListOfEntities = [1, n0, _LOE, 0, () => Entity];
export var ListOfEntityLabels = [1, n0, _LOEL, 0, () => EntityLabel];
export var ListOfErrors = [1, n0, _LOEi, 0, () => ErrorsListItem];
export var ListOfExtractedCharacters = [1, n0, _LOEC, 0, () => ExtractedCharactersListItem];
export var ListOfKeyPhrases = [1, n0, _LOKP, 0, () => KeyPhrase];
export var ListOfLabels = [1, n0, _LOL, 0, () => DocumentLabel];
export var ListOfMentions = [1, n0, _LOM, 0, () => TargetedSentimentMention];
export var ListOfPiiEntities = [1, n0, _LOPE, 0, () => PiiEntity];
export var ListOfPiiEntityTypes = 64 | 0;
export var ListOfRelationships = [1, n0, _LOR, 0, () => RelationshipsListItem];
export var ListOfSyntaxTokens = [1, n0, _LOST, 0, () => SyntaxToken];
export var ListOfTargetedSentimentEntities = [1, n0, _LOTSE, 0, () => TargetedSentimentEntity];
export var ListOfTextSegments = [1, n0, _LOTS, 8, [() => TextSegment, 0]];
export var ListOfToxicContent = [1, n0, _LOTC, 0, () => ToxicContent];
export var ListOfToxicLabels = [1, n0, _LOTL, 0, () => ToxicLabels];
export var ListOfWarnings = [1, n0, _LOW, 0, () => WarningsListItem];
export var PiiEntitiesDetectionJobPropertiesList = [
    1,
    n0,
    _PEDJPL,
    0,
    () => PiiEntitiesDetectionJobProperties,
];
export var Polygon = [1, n0, _Po, 0, () => Point];
export var SecurityGroupIds = 64 | 0;
export var SentimentDetectionJobPropertiesList = [
    1,
    n0,
    _SDJPL,
    0,
    () => SentimentDetectionJobProperties,
];
export var StringList = 64 | 0;
export var Subnets = 64 | 0;
export var TagKeyList = 64 | 0;
export var TagList = [1, n0, _TLa, 0, () => Tag];
export var TargetedSentimentDetectionJobPropertiesList = [
    1,
    n0,
    _TSDJPL,
    0,
    () => TargetedSentimentDetectionJobProperties,
];
export var TargetEventTypes = 64 | 0;
export var TopicsDetectionJobPropertiesList = [1, n0, _TDJPL, 0, () => TopicsDetectionJobProperties];
export var BatchDetectDominantLanguage = [
    9,
    n0,
    _BDDL,
    0,
    () => BatchDetectDominantLanguageRequest,
    () => BatchDetectDominantLanguageResponse,
];
export var BatchDetectEntities = [
    9,
    n0,
    _BDE,
    0,
    () => BatchDetectEntitiesRequest,
    () => BatchDetectEntitiesResponse,
];
export var BatchDetectKeyPhrases = [
    9,
    n0,
    _BDKP,
    0,
    () => BatchDetectKeyPhrasesRequest,
    () => BatchDetectKeyPhrasesResponse,
];
export var BatchDetectSentiment = [
    9,
    n0,
    _BDS,
    0,
    () => BatchDetectSentimentRequest,
    () => BatchDetectSentimentResponse,
];
export var BatchDetectSyntax = [
    9,
    n0,
    _BDSa,
    0,
    () => BatchDetectSyntaxRequest,
    () => BatchDetectSyntaxResponse,
];
export var BatchDetectTargetedSentiment = [
    9,
    n0,
    _BDTS,
    0,
    () => BatchDetectTargetedSentimentRequest,
    () => BatchDetectTargetedSentimentResponse,
];
export var ClassifyDocument = [
    9,
    n0,
    _CD,
    0,
    () => ClassifyDocumentRequest,
    () => ClassifyDocumentResponse,
];
export var ContainsPiiEntities = [
    9,
    n0,
    _CPE,
    0,
    () => ContainsPiiEntitiesRequest,
    () => ContainsPiiEntitiesResponse,
];
export var CreateDataset = [
    9,
    n0,
    _CDr,
    0,
    () => CreateDatasetRequest,
    () => CreateDatasetResponse,
];
export var CreateDocumentClassifier = [
    9,
    n0,
    _CDC,
    0,
    () => CreateDocumentClassifierRequest,
    () => CreateDocumentClassifierResponse,
];
export var CreateEndpoint = [
    9,
    n0,
    _CE,
    0,
    () => CreateEndpointRequest,
    () => CreateEndpointResponse,
];
export var CreateEntityRecognizer = [
    9,
    n0,
    _CERre,
    0,
    () => CreateEntityRecognizerRequest,
    () => CreateEntityRecognizerResponse,
];
export var CreateFlywheel = [
    9,
    n0,
    _CF,
    0,
    () => CreateFlywheelRequest,
    () => CreateFlywheelResponse,
];
export var DeleteDocumentClassifier = [
    9,
    n0,
    _DDC,
    0,
    () => DeleteDocumentClassifierRequest,
    () => DeleteDocumentClassifierResponse,
];
export var DeleteEndpoint = [
    9,
    n0,
    _DE,
    0,
    () => DeleteEndpointRequest,
    () => DeleteEndpointResponse,
];
export var DeleteEntityRecognizer = [
    9,
    n0,
    _DERel,
    0,
    () => DeleteEntityRecognizerRequest,
    () => DeleteEntityRecognizerResponse,
];
export var DeleteFlywheel = [
    9,
    n0,
    _DFe,
    0,
    () => DeleteFlywheelRequest,
    () => DeleteFlywheelResponse,
];
export var DeleteResourcePolicy = [
    9,
    n0,
    _DRP,
    0,
    () => DeleteResourcePolicyRequest,
    () => DeleteResourcePolicyResponse,
];
export var DescribeDataset = [
    9,
    n0,
    _DD,
    0,
    () => DescribeDatasetRequest,
    () => DescribeDatasetResponse,
];
export var DescribeDocumentClassificationJob = [
    9,
    n0,
    _DDCJ,
    0,
    () => DescribeDocumentClassificationJobRequest,
    () => DescribeDocumentClassificationJobResponse,
];
export var DescribeDocumentClassifier = [
    9,
    n0,
    _DDCe,
    0,
    () => DescribeDocumentClassifierRequest,
    () => DescribeDocumentClassifierResponse,
];
export var DescribeDominantLanguageDetectionJob = [
    9,
    n0,
    _DDLDJ,
    0,
    () => DescribeDominantLanguageDetectionJobRequest,
    () => DescribeDominantLanguageDetectionJobResponse,
];
export var DescribeEndpoint = [
    9,
    n0,
    _DEe,
    0,
    () => DescribeEndpointRequest,
    () => DescribeEndpointResponse,
];
export var DescribeEntitiesDetectionJob = [
    9,
    n0,
    _DEDJ,
    0,
    () => DescribeEntitiesDetectionJobRequest,
    () => DescribeEntitiesDetectionJobResponse,
];
export var DescribeEntityRecognizer = [
    9,
    n0,
    _DERescr,
    0,
    () => DescribeEntityRecognizerRequest,
    () => DescribeEntityRecognizerResponse,
];
export var DescribeEventsDetectionJob = [
    9,
    n0,
    _DEDJe,
    0,
    () => DescribeEventsDetectionJobRequest,
    () => DescribeEventsDetectionJobResponse,
];
export var DescribeFlywheel = [
    9,
    n0,
    _DFes,
    0,
    () => DescribeFlywheelRequest,
    () => DescribeFlywheelResponse,
];
export var DescribeFlywheelIteration = [
    9,
    n0,
    _DFI,
    0,
    () => DescribeFlywheelIterationRequest,
    () => DescribeFlywheelIterationResponse,
];
export var DescribeKeyPhrasesDetectionJob = [
    9,
    n0,
    _DKPDJ,
    0,
    () => DescribeKeyPhrasesDetectionJobRequest,
    () => DescribeKeyPhrasesDetectionJobResponse,
];
export var DescribePiiEntitiesDetectionJob = [
    9,
    n0,
    _DPEDJ,
    0,
    () => DescribePiiEntitiesDetectionJobRequest,
    () => DescribePiiEntitiesDetectionJobResponse,
];
export var DescribeResourcePolicy = [
    9,
    n0,
    _DRPe,
    0,
    () => DescribeResourcePolicyRequest,
    () => DescribeResourcePolicyResponse,
];
export var DescribeSentimentDetectionJob = [
    9,
    n0,
    _DSDJ,
    0,
    () => DescribeSentimentDetectionJobRequest,
    () => DescribeSentimentDetectionJobResponse,
];
export var DescribeTargetedSentimentDetectionJob = [
    9,
    n0,
    _DTSDJ,
    0,
    () => DescribeTargetedSentimentDetectionJobRequest,
    () => DescribeTargetedSentimentDetectionJobResponse,
];
export var DescribeTopicsDetectionJob = [
    9,
    n0,
    _DTDJ,
    0,
    () => DescribeTopicsDetectionJobRequest,
    () => DescribeTopicsDetectionJobResponse,
];
export var DetectDominantLanguage = [
    9,
    n0,
    _DDL,
    0,
    () => DetectDominantLanguageRequest,
    () => DetectDominantLanguageResponse,
];
export var DetectEntities = [
    9,
    n0,
    _DEet,
    0,
    () => DetectEntitiesRequest,
    () => DetectEntitiesResponse,
];
export var DetectKeyPhrases = [
    9,
    n0,
    _DKP,
    0,
    () => DetectKeyPhrasesRequest,
    () => DetectKeyPhrasesResponse,
];
export var DetectPiiEntities = [
    9,
    n0,
    _DPE,
    0,
    () => DetectPiiEntitiesRequest,
    () => DetectPiiEntitiesResponse,
];
export var DetectSentiment = [
    9,
    n0,
    _DS,
    0,
    () => DetectSentimentRequest,
    () => DetectSentimentResponse,
];
export var DetectSyntax = [
    9,
    n0,
    _DSe,
    0,
    () => DetectSyntaxRequest,
    () => DetectSyntaxResponse,
];
export var DetectTargetedSentiment = [
    9,
    n0,
    _DTS,
    0,
    () => DetectTargetedSentimentRequest,
    () => DetectTargetedSentimentResponse,
];
export var DetectToxicContent = [
    9,
    n0,
    _DTC,
    0,
    () => DetectToxicContentRequest,
    () => DetectToxicContentResponse,
];
export var ImportModel = [9, n0, _IM, 0, () => ImportModelRequest, () => ImportModelResponse];
export var ListDatasets = [
    9,
    n0,
    _LDi,
    0,
    () => ListDatasetsRequest,
    () => ListDatasetsResponse,
];
export var ListDocumentClassificationJobs = [
    9,
    n0,
    _LDCJ,
    0,
    () => ListDocumentClassificationJobsRequest,
    () => ListDocumentClassificationJobsResponse,
];
export var ListDocumentClassifiers = [
    9,
    n0,
    _LDC,
    0,
    () => ListDocumentClassifiersRequest,
    () => ListDocumentClassifiersResponse,
];
export var ListDocumentClassifierSummaries = [
    9,
    n0,
    _LDCS,
    0,
    () => ListDocumentClassifierSummariesRequest,
    () => ListDocumentClassifierSummariesResponse,
];
export var ListDominantLanguageDetectionJobs = [
    9,
    n0,
    _LDLDJ,
    0,
    () => ListDominantLanguageDetectionJobsRequest,
    () => ListDominantLanguageDetectionJobsResponse,
];
export var ListEndpoints = [
    9,
    n0,
    _LE,
    0,
    () => ListEndpointsRequest,
    () => ListEndpointsResponse,
];
export var ListEntitiesDetectionJobs = [
    9,
    n0,
    _LEDJ,
    0,
    () => ListEntitiesDetectionJobsRequest,
    () => ListEntitiesDetectionJobsResponse,
];
export var ListEntityRecognizers = [
    9,
    n0,
    _LERis,
    0,
    () => ListEntityRecognizersRequest,
    () => ListEntityRecognizersResponse,
];
export var ListEntityRecognizerSummaries = [
    9,
    n0,
    _LERS,
    0,
    () => ListEntityRecognizerSummariesRequest,
    () => ListEntityRecognizerSummariesResponse,
];
export var ListEventsDetectionJobs = [
    9,
    n0,
    _LEDJi,
    0,
    () => ListEventsDetectionJobsRequest,
    () => ListEventsDetectionJobsResponse,
];
export var ListFlywheelIterationHistory = [
    9,
    n0,
    _LFIH,
    0,
    () => ListFlywheelIterationHistoryRequest,
    () => ListFlywheelIterationHistoryResponse,
];
export var ListFlywheels = [
    9,
    n0,
    _LF,
    0,
    () => ListFlywheelsRequest,
    () => ListFlywheelsResponse,
];
export var ListKeyPhrasesDetectionJobs = [
    9,
    n0,
    _LKPDJ,
    0,
    () => ListKeyPhrasesDetectionJobsRequest,
    () => ListKeyPhrasesDetectionJobsResponse,
];
export var ListPiiEntitiesDetectionJobs = [
    9,
    n0,
    _LPEDJ,
    0,
    () => ListPiiEntitiesDetectionJobsRequest,
    () => ListPiiEntitiesDetectionJobsResponse,
];
export var ListSentimentDetectionJobs = [
    9,
    n0,
    _LSDJ,
    0,
    () => ListSentimentDetectionJobsRequest,
    () => ListSentimentDetectionJobsResponse,
];
export var ListTagsForResource = [
    9,
    n0,
    _LTFR,
    0,
    () => ListTagsForResourceRequest,
    () => ListTagsForResourceResponse,
];
export var ListTargetedSentimentDetectionJobs = [
    9,
    n0,
    _LTSDJ,
    0,
    () => ListTargetedSentimentDetectionJobsRequest,
    () => ListTargetedSentimentDetectionJobsResponse,
];
export var ListTopicsDetectionJobs = [
    9,
    n0,
    _LTDJ,
    0,
    () => ListTopicsDetectionJobsRequest,
    () => ListTopicsDetectionJobsResponse,
];
export var PutResourcePolicy = [
    9,
    n0,
    _PRP,
    0,
    () => PutResourcePolicyRequest,
    () => PutResourcePolicyResponse,
];
export var StartDocumentClassificationJob = [
    9,
    n0,
    _SDCJ,
    0,
    () => StartDocumentClassificationJobRequest,
    () => StartDocumentClassificationJobResponse,
];
export var StartDominantLanguageDetectionJob = [
    9,
    n0,
    _SDLDJ,
    0,
    () => StartDominantLanguageDetectionJobRequest,
    () => StartDominantLanguageDetectionJobResponse,
];
export var StartEntitiesDetectionJob = [
    9,
    n0,
    _SEDJ,
    0,
    () => StartEntitiesDetectionJobRequest,
    () => StartEntitiesDetectionJobResponse,
];
export var StartEventsDetectionJob = [
    9,
    n0,
    _SEDJt,
    0,
    () => StartEventsDetectionJobRequest,
    () => StartEventsDetectionJobResponse,
];
export var StartFlywheelIteration = [
    9,
    n0,
    _SFI,
    0,
    () => StartFlywheelIterationRequest,
    () => StartFlywheelIterationResponse,
];
export var StartKeyPhrasesDetectionJob = [
    9,
    n0,
    _SKPDJ,
    0,
    () => StartKeyPhrasesDetectionJobRequest,
    () => StartKeyPhrasesDetectionJobResponse,
];
export var StartPiiEntitiesDetectionJob = [
    9,
    n0,
    _SPEDJ,
    0,
    () => StartPiiEntitiesDetectionJobRequest,
    () => StartPiiEntitiesDetectionJobResponse,
];
export var StartSentimentDetectionJob = [
    9,
    n0,
    _SSDJ,
    0,
    () => StartSentimentDetectionJobRequest,
    () => StartSentimentDetectionJobResponse,
];
export var StartTargetedSentimentDetectionJob = [
    9,
    n0,
    _STSDJ,
    0,
    () => StartTargetedSentimentDetectionJobRequest,
    () => StartTargetedSentimentDetectionJobResponse,
];
export var StartTopicsDetectionJob = [
    9,
    n0,
    _STDJ,
    0,
    () => StartTopicsDetectionJobRequest,
    () => StartTopicsDetectionJobResponse,
];
export var StopDominantLanguageDetectionJob = [
    9,
    n0,
    _SDLDJt,
    0,
    () => StopDominantLanguageDetectionJobRequest,
    () => StopDominantLanguageDetectionJobResponse,
];
export var StopEntitiesDetectionJob = [
    9,
    n0,
    _SEDJto,
    0,
    () => StopEntitiesDetectionJobRequest,
    () => StopEntitiesDetectionJobResponse,
];
export var StopEventsDetectionJob = [
    9,
    n0,
    _SEDJtop,
    0,
    () => StopEventsDetectionJobRequest,
    () => StopEventsDetectionJobResponse,
];
export var StopKeyPhrasesDetectionJob = [
    9,
    n0,
    _SKPDJt,
    0,
    () => StopKeyPhrasesDetectionJobRequest,
    () => StopKeyPhrasesDetectionJobResponse,
];
export var StopPiiEntitiesDetectionJob = [
    9,
    n0,
    _SPEDJt,
    0,
    () => StopPiiEntitiesDetectionJobRequest,
    () => StopPiiEntitiesDetectionJobResponse,
];
export var StopSentimentDetectionJob = [
    9,
    n0,
    _SSDJt,
    0,
    () => StopSentimentDetectionJobRequest,
    () => StopSentimentDetectionJobResponse,
];
export var StopTargetedSentimentDetectionJob = [
    9,
    n0,
    _STSDJt,
    0,
    () => StopTargetedSentimentDetectionJobRequest,
    () => StopTargetedSentimentDetectionJobResponse,
];
export var StopTrainingDocumentClassifier = [
    9,
    n0,
    _STDC,
    0,
    () => StopTrainingDocumentClassifierRequest,
    () => StopTrainingDocumentClassifierResponse,
];
export var StopTrainingEntityRecognizer = [
    9,
    n0,
    _STER,
    0,
    () => StopTrainingEntityRecognizerRequest,
    () => StopTrainingEntityRecognizerResponse,
];
export var TagResource = [9, n0, _TR, 0, () => TagResourceRequest, () => TagResourceResponse];
export var UntagResource = [
    9,
    n0,
    _UR,
    0,
    () => UntagResourceRequest,
    () => UntagResourceResponse,
];
export var UpdateEndpoint = [
    9,
    n0,
    _UE,
    0,
    () => UpdateEndpointRequest,
    () => UpdateEndpointResponse,
];
export var UpdateFlywheel = [
    9,
    n0,
    _UF,
    0,
    () => UpdateFlywheelRequest,
    () => UpdateFlywheelResponse,
];
